{
  "level": "bs02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs02",
    "objects": "AREAS.E3:bs02.e3",
    "mesh": "TREES.E3:bs02.e3"
  },
  "spawn_point": {
    "position": [
      -3285.8908910243786,
      -4493.739567832341,
      1006.623779296875
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3285.8908910243786,
      -4393.739567832341,
      1006.623779296875
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4007.749267578125,
      -5045.98291015625,
      982.623779296875
    ],
    "bbox_max": [
      -1964.791748046875,
      -3619.7685546875,
      1402.623779296875
    ],
    "vertex_count": 1071,
    "vertices": [
      [
        -3345.367919921875,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3342.380126953125,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3374.21240234375,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3380.1875,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3412.019775390625,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3409.031982421875,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3407.68359375,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3410.255615234375,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3410.255615234375,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3412.019775390625,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3409.031982421875,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3407.68359375,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3379.771728515625,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3374.628173828125,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3380.1875,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3379.771728515625,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3374.628173828125,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3374.21240234375,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3344.14453125,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3346.71630859375,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3342.380126953125,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3344.14453125,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3346.71630859375,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3345.367919921875,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3359.619873046875,
        -4342.0966796875,
        1052.623779296875
      ],
      [
        -3356.632080078125,
        -4336.92236328125,
        1052.623779296875
      ],
      [
        -3355.28369140625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3357.855712890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3357.855712890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3359.619873046875,
        -4342.0966796875,
        1052.623779296875
      ],
      [
        -3356.632080078125,
        -4336.92236328125,
        1052.623779296875
      ],
      [
        -3355.28369140625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3271.8125,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3277.78759765625,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3242.968017578125,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3239.980224609375,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3309.619873046875,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3306.632080078125,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3305.28369140625,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3307.855712890625,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3307.855712890625,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3309.619873046875,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3306.632080078125,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3305.28369140625,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3277.371826171875,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3272.228271484375,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3277.78759765625,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3277.371826171875,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3272.228271484375,
        -4317.43408203125,
        1052.623779296875
      ],
      [
        -3271.8125,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3241.74462890625,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3244.31640625,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3239.980224609375,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3241.74462890625,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3244.31640625,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3242.968017578125,
        -4258.92236328125,
        1052.623779296875
      ],
      [
        -3292.968017578125,
        -4336.92236328125,
        1052.623779296875
      ],
      [
        -3289.980224609375,
        -4342.0966796875,
        1052.623779296875
      ],
      [
        -3291.74462890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3294.31640625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3289.980224609375,
        -4342.0966796875,
        1052.623779296875
      ],
      [
        -3291.74462890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3294.31640625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3292.968017578125,
        -4336.92236328125,
        1052.623779296875
      ],
      [
        -3092.50146484375,
        -4525.01611328125,
        1052.623779296875
      ],
      [
        -3092.50048828125,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4525.01611328125,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3321.8125,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -3327.78759765625,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -3327.371826171875,
        -4395.43408203125,
        1052.623779296875
      ],
      [
        -3322.228271484375,
        -4395.43408203125,
        1052.623779296875
      ],
      [
        -3327.78759765625,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -3327.371826171875,
        -4395.43408203125,
        1052.623779296875
      ],
      [
        -3322.228271484375,
        -4395.43408203125,
        1052.623779296875
      ],
      [
        -3321.8125,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -3836.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      [
        -3836.999755859375,
        -4499.7685546875,
        982.623779296875
      ],
      [
        -3886.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      [
        -3886.999755859375,
        -4439.7685546875,
        1012.623779296875
      ],
      [
        -3671.062255859375,
        -4323.1533203125,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3675.689208984375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4318.73876953125,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4318.46484375,
        1027.9342041015625
      ],
      [
        -3675.999755859375,
        -4318.46484375,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4318.46484375,
        1027.9342041015625
      ],
      [
        -3675.999755859375,
        -4318.73876953125,
        1027.623779296875
      ],
      [
        -3675.711181640625,
        -4318.73876953125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4318.73876953125,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4318.73876953125,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      [
        -3632.400390625,
        -4346.03955078125,
        1010.196044921875
      ],
      [
        -3625.745849609375,
        -4346.03955078125,
        1010.196044921875
      ],
      [
        -3625.745849609375,
        -4346.03955078125,
        1010.196044921875
      ],
      [
        -3632.400390625,
        -4346.03955078125,
        1010.196044921875
      ],
      [
        -3675.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      [
        -3667.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      [
        -3667.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      [
        -3675.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      [
        -3675.999755859375,
        -4339.71875,
        1008.8607177734375
      ],
      [
        -3667.999755859375,
        -4339.71875,
        1008.8607177734375
      ],
      [
        -3675.999755859375,
        -4339.71875,
        1015.7047729492188
      ],
      [
        -3667.999755859375,
        -4339.71875,
        1015.7047729492188
      ],
      [
        -3667.999755859375,
        -4339.71875,
        1015.7047729492188
      ],
      [
        -3675.999755859375,
        -4339.71875,
        1015.7047729492188
      ],
      [
        -3735.253173828125,
        -4670.39599609375,
        1032.5999755859375
      ],
      [
        -3735.253173828125,
        -4670.39599609375,
        1002.5999755859375
      ],
      [
        -3665.853271484375,
        -4632.0185546875,
        1027.623779296875
      ],
      [
        -3650.999755859375,
        -4617.966796875,
        1027.623779296875
      ],
      [
        -3650.999755859375,
        -4616.06787109375,
        1027.623779296875
      ],
      [
        -3668.242919921875,
        -4632.0185546875,
        1027.623779296875
      ],
      [
        -3650.999755859375,
        -4617.966796875,
        1027.623779296875
      ],
      [
        -3665.853271484375,
        -4632.0185546875,
        1027.623779296875
      ],
      [
        -3665.853271484375,
        -4632.0185546875,
        1029.413818359375
      ],
      [
        -3650.999755859375,
        -4617.966796875,
        1029.1614990234375
      ],
      [
        -3667.999755859375,
        -4651.576171875,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4651.576171875,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4651.576171875,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4651.576171875,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4634.04931640625,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4641.6171875,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4641.6171875,
        1029.586181640625
      ],
      [
        -3667.999755859375,
        -4634.04931640625,
        1029.4503173828125
      ],
      [
        -3675.999755859375,
        -4641.6171875,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4634.04931640625,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4632.0185546875,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4639.19384765625,
        1027.623779296875
      ],
      [
        -3682.06884765625,
        -4647.3583984375,
        1027.623779296875
      ],
      [
        -3684.82568359375,
        -4647.3583984375,
        1027.623779296875
      ],
      [
        -3682.06884765625,
        -4647.3583984375,
        1027.623779296875
      ],
      [
        -3683.94775390625,
        -4649.13623046875,
        1029.72119140625
      ],
      [
        -3684.999755859375,
        -4650.13134765625,
        1029.739013671875
      ],
      [
        -3684.999755859375,
        -4647.51953125,
        1027.623779296875
      ],
      [
        -3617.999755859375,
        -4586.748046875,
        1028.60107421875
      ],
      [
        -3617.999755859375,
        -4585.541015625,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4637.44140625,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4637.44140625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4637.44140625,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4637.44140625,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4306.18603515625,
        1050.3369140625
      ],
      [
        -3624.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      [
        -3629.4326171875,
        -4304.1669921875,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4306.18603515625,
        1050.3369140625
      ],
      [
        -3624.999755859375,
        -4306.18603515625,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4656.68115234375,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4656.68115234375,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4656.68115234375,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4656.68115234375,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4641.748046875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4641.748046875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4641.748046875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4641.748046875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3675.689208984375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4318.46484375,
        1032.9339599609375
      ],
      [
        -3675.999755859375,
        -4318.46484375,
        1032.9339599609375
      ],
      [
        -3675.999755859375,
        -4318.46484375,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4301.0810546875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4301.0810546875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4301.0810546875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4301.0810546875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4308.5810546875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4308.5810546875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4308.5810546875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4308.5810546875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4668.54638671875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4668.54638671875,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4668.54638671875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4668.54638671875,
        1052.623779296875
      ],
      [
        -3675.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4651.7568359375,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4651.7568359375,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4651.7568359375,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4651.7568359375,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1082.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1187.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1226.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1101.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1121.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1187.623779296875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1113.623779296875
      ],
      [
        -2617.66015625,
        -4064.33154296875,
        1101.623779296875
      ],
      [
        -2617.66015625,
        -4064.33154296875,
        1112.623779296875
      ],
      [
        -2617.66015625,
        -4064.33154296875,
        1112.623779296875
      ],
      [
        -2617.66015625,
        -4064.33154296875,
        1121.623779296875
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1112.623779296875
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1121.623779296875
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1113.623779296875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1113.623779296875
      ],
      [
        -2631.5166015625,
        -4056.33154296875,
        1101.623779296875
      ],
      [
        -2631.5166015625,
        -4056.33154296875,
        1112.623779296875
      ],
      [
        -2631.5166015625,
        -4056.33154296875,
        1112.623779296875
      ],
      [
        -2631.516357421875,
        -4056.33154296875,
        1121.623779296875
      ],
      [
        -3041.499755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1121.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2845.2509765625,
        -3898.5556640625,
        1121.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1121.623779296875
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1121.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1121.623779296875
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1121.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1121.623779296875
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1121.623779296875
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1121.623779296875
      ],
      [
        -3003.1396484375,
        -4054.818603515625,
        1121.623779296875
      ],
      [
        -2994.94970703125,
        -4054.818603515625,
        1121.623779296875
      ],
      [
        -2725.0498046875,
        -4054.818603515625,
        1121.623779296875
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1121.623779296875
      ],
      [
        -3003.1396484375,
        -4046.718505859375,
        1121.623779296875
      ],
      [
        -3003.1396484375,
        -4054.818603515625,
        1121.623779296875
      ],
      [
        -2725.0498046875,
        -4046.718505859375,
        1121.623779296875
      ],
      [
        -2725.0498046875,
        -4054.818603515625,
        1121.623779296875
      ],
      [
        -2781.716552734375,
        -4020.4853515625,
        1121.623779296875
      ],
      [
        -2780.28271484375,
        -4020.4853515625,
        1121.623779296875
      ],
      [
        -2781.716552734375,
        -4019.0517578125,
        1121.623779296875
      ],
      [
        -2781.716552734375,
        -4020.4853515625,
        1121.623779296875
      ],
      [
        -2939.716796875,
        -4020.4853515625,
        1121.623779296875
      ],
      [
        -2938.282958984375,
        -4020.4853515625,
        1121.623779296875
      ],
      [
        -2939.716796875,
        -4019.0517578125,
        1121.623779296875
      ],
      [
        -2939.716796875,
        -4020.4853515625,
        1121.623779296875
      ],
      [
        -2856.216796875,
        -4051.4853515625,
        1121.623779296875
      ],
      [
        -2854.782958984375,
        -4051.4853515625,
        1121.623779296875
      ],
      [
        -2856.216796875,
        -4050.0517578125,
        1121.623779296875
      ],
      [
        -2856.216796875,
        -4051.4853515625,
        1121.623779296875
      ],
      [
        -2781.716552734375,
        -4082.4853515625,
        1121.623779296875
      ],
      [
        -2780.28271484375,
        -4082.4853515625,
        1121.623779296875
      ],
      [
        -2781.716552734375,
        -4081.0517578125,
        1121.623779296875
      ],
      [
        -2781.716552734375,
        -4082.4853515625,
        1121.623779296875
      ],
      [
        -2939.716796875,
        -4082.4853515625,
        1121.623779296875
      ],
      [
        -2938.282958984375,
        -4082.4853515625,
        1121.623779296875
      ],
      [
        -2939.716796875,
        -4081.0517578125,
        1121.623779296875
      ],
      [
        -2939.716796875,
        -4082.4853515625,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1121.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1185.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1121.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1185.623779296875
      ],
      [
        -2939.499755859375,
        -4020.02294921875,
        1137.623779296875
      ],
      [
        -2939.716796875,
        -4020.133056640625,
        1121.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1121.623779296875
      ],
      [
        -2781.499755859375,
        -4019.513916015625,
        1137.623779296875
      ],
      [
        -2781.716552734375,
        -4019.404052734375,
        1121.623779296875
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1139.873779296875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1121.623779296875
      ],
      [
        -2855.999755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      [
        -2856.216796875,
        -4050.7685546875,
        1121.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1121.623779296875
      ],
      [
        -2939.499755859375,
        -4081.514404296875,
        1137.623779296875
      ],
      [
        -2939.716796875,
        -4081.404052734375,
        1121.623779296875
      ],
      [
        -3599.999755859375,
        -4190.0830078125,
        1102.623779296875
      ],
      [
        -3301.525146484375,
        -3890.92822265625,
        1100.8765869140625
      ],
      [
        -3301.525146484375,
        -3890.92822265625,
        1100.8765869140625
      ],
      [
        -3293.08740234375,
        -3899.365966796875,
        1052.623779296875
      ],
      [
        -3600.0,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3292.686279296875,
        -3899.76708984375,
        1052.623779296875
      ],
      [
        -3119.630615234375,
        -3947.0,
        1085.0478515625
      ],
      [
        -3108.0,
        -3941.97265625,
        1080.623779296875
      ],
      [
        -3160.0,
        -3950.0,
        1100.4039306640625
      ],
      [
        -3126.57080078125,
        -3950.0,
        1102.623779296875
      ],
      [
        -3126.57080078125,
        -3950.0,
        1087.6878662109375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1096.487548828125
      ],
      [
        -3126.57080078125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3149.70458984375,
        -3960.0,
        1082.623779296875
      ],
      [
        -3109.968505859375,
        -4017.080322265625,
        1102.623779296875
      ],
      [
        -3147.163818359375,
        -4004.833740234375,
        1102.623779296875
      ],
      [
        -3193.400390625,
        -3999.052978515625,
        1082.623779296875
      ],
      [
        -3196.19921875,
        -3996.254150390625,
        1086.5999755859375
      ],
      [
        -3172.28076171875,
        -4020.172607421875,
        1052.623779296875
      ],
      [
        -3193.400390625,
        -3999.052978515625,
        1082.623779296875
      ],
      [
        -3109.968505859375,
        -4018.5,
        1099.616943359375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1082.623779296875
      ],
      [
        -3112.968505859375,
        -4018.5,
        1097.5247802734375
      ],
      [
        -3112.968505859375,
        -3947.0,
        1082.513671875
      ],
      [
        -3112.968505859375,
        -3944.120361328125,
        1082.513671875
      ],
      [
        -3139.685546875,
        -4012.31201171875,
        1092.0
      ],
      [
        -3147.163818359375,
        -4004.833740234375,
        1102.623779296875
      ],
      [
        -3120.891357421875,
        -4018.5,
        1092.0
      ],
      [
        -3128.48486328125,
        -4016.0,
        1092.0
      ],
      [
        -3135.9619140625,
        -4013.5380859375,
        1092.0
      ],
      [
        -3139.685546875,
        -4012.31201171875,
        1092.0
      ],
      [
        -3112.968505859375,
        -3950.0,
        1092.0
      ],
      [
        -3126.57080078125,
        -3950.0,
        1092.0
      ],
      [
        -3150.0,
        -3985.0,
        1092.0
      ],
      [
        -3140.0,
        -3985.0,
        1092.0
      ],
      [
        -3150.0,
        -3975.0,
        1092.0
      ],
      [
        -3150.0,
        -3985.0,
        1092.0
      ],
      [
        -3149.70458984375,
        -3960.0,
        1092.0
      ],
      [
        -3140.0,
        -3960.0,
        1092.0
      ],
      [
        -3117.0,
        -4018.5,
        1094.7132568359375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1092.0
      ],
      [
        -3117.0,
        -4018.5,
        1094.7132568359375
      ],
      [
        -3120.891357421875,
        -4018.5,
        1092.0
      ],
      [
        -3502.938720703125,
        -4189.7685546875,
        1302.623779296875
      ],
      [
        -3439.048583984375,
        -4197.71923828125,
        1121.623779296875
      ],
      [
        -3435.49072265625,
        -4201.27734375,
        1102.62255859375
      ],
      [
        -3435.49072265625,
        -4201.27734375,
        1052.623779296875
      ],
      [
        -3429.128173828125,
        -4189.14013671875,
        1121.623779296875
      ],
      [
        -3425.5703125,
        -4192.6982421875,
        1102.623291015625
      ],
      [
        -3425.5703125,
        -4192.6982421875,
        1097.2947998046875
      ],
      [
        -3428.32373046875,
        -4188.44482421875,
        1121.623779296875
      ],
      [
        -3429.128173828125,
        -4189.14013671875,
        1121.623779296875
      ],
      [
        -3438.244384765625,
        -4197.02392578125,
        1121.623779296875
      ],
      [
        -3434.6865234375,
        -4200.58203125,
        1096.7835693359375
      ],
      [
        -3434.6865234375,
        -4200.58203125,
        1102.6231689453125
      ],
      [
        -3439.048583984375,
        -4197.71923828125,
        1121.623779296875
      ],
      [
        -3438.244384765625,
        -4197.02392578125,
        1121.623779296875
      ],
      [
        -3425.570068359375,
        -4192.6982421875,
        1097.2947998046875
      ],
      [
        -3433.9482421875,
        -4199.943359375,
        1096.8094482421875
      ],
      [
        -3434.6865234375,
        -4200.58203125,
        1096.7835693359375
      ],
      [
        -3433.9482421875,
        -4199.943359375,
        1096.8094482421875
      ],
      [
        -3426.12841796875,
        -4210.6396484375,
        1052.623779296875
      ],
      [
        -3424.660400390625,
        -4193.60791015625,
        1097.7650146484375
      ],
      [
        -3432.78125,
        -4200.78173828125,
        1097.331787109375
      ],
      [
        -3433.690185546875,
        -4201.578125,
        1097.302490234375
      ],
      [
        -3424.66064453125,
        -4193.60791015625,
        1097.7650146484375
      ],
      [
        -3433.690185546875,
        -4201.578125,
        1097.302490234375
      ],
      [
        -3432.78125,
        -4200.78173828125,
        1097.331787109375
      ],
      [
        -3193.511474609375,
        -3998.94189453125,
        1082.7816162109375
      ],
      [
        -3194.2265625,
        -3998.226806640625,
        1086.5999755859375
      ],
      [
        -3208.600830078125,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3182.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3208.600830078125,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3210.25927734375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3210.25927734375,
        -4179.7685546875,
        1084.9443359375
      ],
      [
        -3181.398681640625,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3179.740234375,
        -4179.7685546875,
        1084.9443359375
      ],
      [
        -3179.740234375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3169.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3182.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3167.36328125,
        -4249.72412109375,
        1067.623779296875
      ],
      [
        -3169.97509765625,
        -4249.7685546875,
        1071.2789306640625
      ],
      [
        -3167.36328125,
        -4249.72412109375,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4179.7685546875,
        1063.970458984375
      ],
      [
        -3167.36328125,
        -4249.72412109375,
        1063.970458984375
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3169.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3169.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3167.36328125,
        -4249.72412109375,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1063.9708251953125
      ],
      [
        -3222.63623046875,
        -4179.7685546875,
        1063.9708251953125
      ],
      [
        -3222.63623046875,
        -4082.515380859375,
        1067.6236572265625
      ],
      [
        -3219.063232421875,
        -4074.390625,
        1072.623779296875
      ],
      [
        -3216.391357421875,
        -4071.71044921875,
        1072.623779296875
      ],
      [
        -3222.63623046875,
        -4085.8330078125,
        1063.9705810546875
      ],
      [
        -3222.63623046875,
        -4088.645263671875,
        1067.62353515625
      ],
      [
        -3219.063232421875,
        -4082.572265625,
        1072.623779296875
      ],
      [
        -3216.391357421875,
        -4079.900390625,
        1072.623779296875
      ],
      [
        -3222.63623046875,
        -4090.471923828125,
        1063.9705810546875
      ],
      [
        -3219.063232421875,
        -4074.390625,
        1072.623779296875
      ],
      [
        -3216.391357421875,
        -4071.71044921875,
        1072.623779296875
      ],
      [
        -3216.391357421875,
        -4079.900390625,
        1072.623779296875
      ],
      [
        -3219.063232421875,
        -4082.572265625,
        1072.623779296875
      ],
      [
        -3227.390625,
        -4096.5849609375,
        1057.382568359375
      ],
      [
        -3228.3857421875,
        -4095.589599609375,
        1059.5777587890625
      ],
      [
        -3230.8251953125,
        -4093.150146484375,
        1052.623779296875
      ],
      [
        -3233.35498046875,
        -4090.620361328125,
        1052.623779296875
      ],
      [
        -3228.3857421875,
        -4095.589599609375,
        1059.5777587890625
      ],
      [
        -3227.390625,
        -4096.5849609375,
        1057.382568359375
      ],
      [
        -3226.671875,
        -4097.3037109375,
        1058.3785400390625
      ],
      [
        -3227.338134765625,
        -4096.63720703125,
        1061.0435791015625
      ],
      [
        -3227.401611328125,
        -4096.57421875,
        1057.367431640625
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4085.8330078125,
        1063.9705810546875
      ],
      [
        -3219.999755859375,
        -4079.870849609375,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4091.02783203125,
        1055.3375244140625
      ],
      [
        -3222.63623046875,
        -4094.9140625,
        1053.9703369140625
      ],
      [
        -3219.999755859375,
        -4093.5087890625,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4096.1455078125,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4090.471923828125,
        1063.9705810546875
      ],
      [
        -3219.999755859375,
        -4086.0087890625,
        1067.623779296875
      ],
      [
        -3219.063232421875,
        -4074.43896484375,
        1072.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3046.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4206.7998046875,
        1102.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3667.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3675.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3624.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3632.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3632.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3624.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3632.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3632.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3624.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3624.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3675.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3754.28271484375,
        -4249.7685546875,
        1302.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4981.9541015625,
        1302.623779296875
      ],
      [
        -2749.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2799.999755859375,
        -4719.2421875,
        1231.90625
      ],
      [
        -2920.0,
        -4850.7685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4821.984375,
        1082.623779296875
      ],
      [
        -2920.0,
        -4835.04296875,
        1082.623779296875
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2919.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      [
        -2919.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2919.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1068.6842041015625
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1068.6842041015625
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -3699.999755859375,
        -4260.35546875,
        1102.623779296875
      ],
      [
        -3729.92431640625,
        -4249.7685546875,
        1222.32177734375
      ],
      [
        -3699.999755859375,
        -4260.80517578125,
        1102.623779296875
      ],
      [
        -3733.5146484375,
        -4249.7685546875,
        1236.6832275390625
      ],
      [
        -3699.999755859375,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3599.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3319.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3580.227294921875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3597.65576171875,
        -4740.40869140625,
        1112.0
      ],
      [
        -3597.65576171875,
        -4740.40869140625,
        1112.0
      ],
      [
        -3580.22705078125,
        -4739.54150390625,
        1181.71435546875
      ],
      [
        -2964.98583984375,
        -4737.49853515625,
        1082.623779296875
      ],
      [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2968.409423828125,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -2964.98583984375,
        -4737.4990234375,
        1052.623779296875
      ],
      [
        -2958.458740234375,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2964.98583984375,
        -4737.49853515625,
        1082.623779296875
      ],
      [
        -2956.077392578125,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3199.588623046875,
        -4741.14697265625,
        1052.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3231.590087890625,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3231.940185546875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3244.087890625,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3243.922119140625,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3243.922119140625,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3231.940185546875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3624.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1054.3406982421875
      ],
      [
        -3632.999755859375,
        -4679.7998046875,
        1054.3406982421875
      ],
      [
        -3632.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      [
        -3675.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      [
        -3675.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      [
        -3632.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      [
        -3632.999755859375,
        -4679.7998046875,
        1054.3406982421875
      ],
      [
        -3632.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3632.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3632.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3632.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1054.3406982421875
      ],
      [
        -3624.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      [
        -3667.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4679.7998046875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4679.7998046875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      [
        -3675.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.965576171875,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.9658203125,
        -4854.802734375,
        1202.7596435546875
      ],
      [
        -3574.9658203125,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1102.6241455078125
      ],
      [
        -3332.493896484375,
        -4850.7685546875,
        1152.5999755859375
      ],
      [
        -3574.9658203125,
        -4854.802734375,
        1202.759765625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3319.999755859375,
        -4947.19970703125,
        1212.34912109375
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3111.6005859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3111.6005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3054.07763671875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3015.14697265625,
        -4935.62158203125,
        1092.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3015.14697265625,
        -4935.62158203125,
        1092.623779296875
      ],
      [
        -2989.13427734375,
        -4896.6904296875,
        1092.623779296875
      ],
      [
        -2989.13427734375,
        -4896.6904296875,
        1092.623779296875
      ],
      [
        -2979.999755859375,
        -4850.7685546875,
        1092.623779296875
      ],
      [
        -3054.07763671875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3070.73876953125,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3070.73876953125,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3116.0166015625,
        -4965.7685546875,
        1100.5728759765625
      ],
      [
        -3111.6005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3091.182861328125,
        -4965.7685546875,
        1114.5679931640625
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1106.5679931640625
      ],
      [
        -3099.999755859375,
        -4965.7685546875,
        1117.623779296875
      ],
      [
        -3091.182861328125,
        -4965.7685546875,
        1114.5679931640625
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1106.5679931640625
      ],
      [
        -3085.73388671875,
        -4965.7685546875,
        1101.606689453125
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1092.623779296875
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1092.623779296875
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3062.9287109375,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1092.623779296875
      ],
      [
        -3055.038818359375,
        -4764.3359375,
        1092.623779296875
      ],
      [
        -3096.669677734375,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3082.365966796875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3083.73388671875,
        -4934.7685546875,
        1103.6322021484375
      ],
      [
        -3093.06982421875,
        -4934.7685546875,
        1117.338623046875
      ],
      [
        -3114.42626953125,
        -4939.7685546875,
        1122.623779296875
      ],
      [
        -3103.053466796875,
        -4934.7685546875,
        1118.68212890625
      ],
      [
        -3103.053466796875,
        -4939.7685546875,
        1118.68212890625
      ],
      [
        -3103.053466796875,
        -4934.7685546875,
        1118.68212890625
      ],
      [
        -3015.14697265625,
        -4935.62158203125,
        1082.623779296875
      ],
      [
        -3015.14697265625,
        -4935.62158203125,
        1082.623779296875
      ],
      [
        -2989.13427734375,
        -4896.6904296875,
        1082.623779296875
      ],
      [
        -2989.13427734375,
        -4896.6904296875,
        1082.623779296875
      ],
      [
        -2979.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3106.045166015625,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3089.37841796875,
        -4965.7685546875,
        1052.623779296875
      ],
      [
        -3093.6240234375,
        -4879.7685546875,
        1060.266357421875
      ],
      [
        -3096.18310546875,
        -4879.7685546875,
        1064.872802734375
      ],
      [
        -3093.966064453125,
        -4899.7685546875,
        1060.8817138671875
      ],
      [
        -3093.966064453125,
        -4890.423828125,
        1060.8817138671875
      ],
      [
        -3062.9287109375,
        -4932.697265625,
        1052.86376953125
      ],
      [
        -3062.9287109375,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1054.6905517578125
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1054.6905517578125
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1056.5172119140625
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1057.2738037109375
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1082.623779296875
      ],
      [
        -3077.07080078125,
        -4946.83984375,
        1056.5172119140625
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1056.5172119140625
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1082.623779296875
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1057.2738037109375
      ],
      [
        -3093.966064453125,
        -4890.423828125,
        1060.8817138671875
      ],
      [
        -3093.6240234375,
        -4879.7685546875,
        1060.266357421875
      ],
      [
        -3097.450439453125,
        -4859.7685546875,
        1067.1539306640625
      ],
      [
        -3098.36865234375,
        -4872.97900390625,
        1068.8065185546875
      ],
      [
        -3098.36865234375,
        -4879.7685546875,
        1068.8065185546875
      ],
      [
        -3098.36865234375,
        -4872.97900390625,
        1068.8065185546875
      ],
      [
        -3026.156494140625,
        -4799.3642578125,
        1082.623779296875
      ],
      [
        -3027.5712890625,
        -4798.88037109375,
        1082.623779296875
      ],
      [
        -3030.836181640625,
        -4800.23291015625,
        1082.09375
      ],
      [
        -3040.399658203125,
        -4807.7041015625,
        1079.7874755859375
      ],
      [
        -3039.5458984375,
        -4864.84912109375,
        1082.623779296875
      ],
      [
        -3037.97314453125,
        -4861.71044921875,
        1082.623779296875
      ],
      [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1078.227783203125
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1078.227783203125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1078.74072265625
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1078.74072265625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1077.646728515625
      ],
      [
        -3077.999755859375,
        -4859.7685546875,
        1072.9267578125
      ],
      [
        -3070.636962890625,
        -4858.3037109375,
        1068.1158447265625
      ],
      [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      [
        -3077.999755859375,
        -4859.7685546875,
        1072.9267578125
      ],
      [
        -3087.82666015625,
        -4859.7685546875,
        1070.6024169921875
      ],
      [
        -3097.450439453125,
        -4859.7685546875,
        1067.1539306640625
      ],
      [
        -3095.99169921875,
        -4859.7685546875,
        1064.5283203125
      ],
      [
        -3086.44775390625,
        -4859.7685546875,
        1065.2291259765625
      ],
      [
        -3084.099609375,
        -4859.7685546875,
        1065.649658203125
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1077.646728515625
      ],
      [
        -3038.148193359375,
        -4819.02197265625,
        1077.523193359375
      ],
      [
        -3037.97314453125,
        -4861.71044921875,
        1082.623779296875
      ],
      [
        -3037.782958984375,
        -4859.9853515625,
        1082.623779296875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1081.0933837890625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1081.4393310546875
      ],
      [
        -3030.836181640625,
        -4800.23291015625,
        1082.09375
      ],
      [
        -3027.5712890625,
        -4798.88037109375,
        1082.623779296875
      ],
      [
        -3028.7900390625,
        -4798.87841796875,
        1082.623779296875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1081.0933837890625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1081.4393310546875
      ],
      [
        -3040.399658203125,
        -4807.7041015625,
        1079.7874755859375
      ],
      [
        -3039.420166015625,
        -4812.62744140625,
        1080.876953125
      ],
      [
        -3037.782958984375,
        -4859.9853515625,
        1082.623779296875
      ],
      [
        -3036.741943359375,
        -4845.5087890625,
        1082.623779296875
      ],
      [
        -3036.741943359375,
        -4845.5087890625,
        1082.623779296875
      ],
      [
        -3036.1943359375,
        -4837.0849609375,
        1082.623779296875
      ],
      [
        -3039.73974609375,
        -4828.515625,
        1082.623779296875
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1082.45703125
      ],
      [
        -3038.4208984375,
        -4821.88623046875,
        1082.623779296875
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1082.45703125
      ],
      [
        -3095.482177734375,
        -4859.7685546875,
        1063.6112060546875
      ],
      [
        -3106.044921875,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3102.653076171875,
        -4767.8212890625,
        1076.518798828125
      ],
      [
        -3090.634033203125,
        -4766.8359375,
        1078.489501953125
      ],
      [
        -3089.600341796875,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3044.791259765625,
        -4798.85400390625,
        1082.623779296875
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1082.623779296875
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      [
        -3021.355224609375,
        -4802.8994140625,
        1082.623779296875
      ],
      [
        -3024.63525390625,
        -4799.884765625,
        1082.623779296875
      ],
      [
        -3024.63525390625,
        -4799.884765625,
        1082.623779296875
      ],
      [
        -3102.450927734375,
        -4768.0029296875,
        1076.155029296875
      ],
      [
        -3090.7392578125,
        -4767.04638671875,
        1078.0682373046875
      ],
      [
        -3100.4892578125,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3095.13330078125,
        -4859.7685546875,
        1062.983154296875
      ],
      [
        -3106.045166015625,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3039.798095703125,
        -4810.72802734375,
        1082.623779296875
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1083.45703125
      ],
      [
        -3066.577880859375,
        -4762.04052734375,
        1092.623779296875
      ],
      [
        -3091.98583984375,
        -4759.7685546875,
        1092.623779296875
      ],
      [
        -3087.185302734375,
        -4759.9384765625,
        1092.28369140625
      ],
      [
        -3111.587158203125,
        -4759.78076171875,
        1092.599365234375
      ],
      [
        -3087.4404296875,
        -4760.44873046875,
        1091.2637939453125
      ],
      [
        -3270.044677734375,
        -4850.69775390625,
        1082.623779296875
      ],
      [
        -3270.07763671875,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3223.016357421875,
        -4750.28173828125,
        1082.623779296875
      ],
      [
        -3270.044677734375,
        -4850.6982421875,
        1082.623779296875
      ],
      [
        -3108.5498046875,
        -4895.28515625,
        1064.649169921875
      ],
      [
        -3109.7431640625,
        -4879.7685546875,
        1064.161865234375
      ],
      [
        -3109.7431640625,
        -4879.7685546875,
        1064.161865234375
      ],
      [
        -3102.477783203125,
        -4879.7685546875,
        1067.12841796875
      ],
      [
        -3108.5498046875,
        -4899.7685546875,
        1064.649169921875
      ],
      [
        -3108.5498046875,
        -4895.28515625,
        1064.649169921875
      ],
      [
        -3175.3642578125,
        -4819.884765625,
        1082.623779296875
      ],
      [
        -3178.644287109375,
        -4822.8994140625,
        1082.623779296875
      ],
      [
        -3177.4326171875,
        -4862.7294921875,
        1082.623779296875
      ],
      [
        -3164.42626953125,
        -4882.19482421875,
        1082.623779296875
      ],
      [
        -3181.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      [
        -3177.4326171875,
        -4862.7294921875,
        1082.623779296875
      ],
      [
        -3172.42822265625,
        -4818.88037109375,
        1082.623779296875
      ],
      [
        -3175.3642578125,
        -4819.884765625,
        1082.623779296875
      ],
      [
        -3109.385498046875,
        -4884.41845703125,
        1064.307861328125
      ],
      [
        -3115.899658203125,
        -4879.7685546875,
        1065.649658203125
      ],
      [
        -3178.644287109375,
        -4822.8994140625,
        1082.623779296875
      ],
      [
        -3181.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      [
        -3115.899658203125,
        -4879.7685546875,
        1065.649658203125
      ],
      [
        -3113.549072265625,
        -4879.7685546875,
        1065.228759765625
      ],
      [
        -3108.10888671875,
        -4879.7685546875,
        1064.8292236328125
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1070.6708984375
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1073.3734130859375
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1070.6708984375
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1069.59814453125
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1069.59814453125
      ],
      [
        -3129.36328125,
        -4878.3037109375,
        1068.115966796875
      ],
      [
        -3109.08740234375,
        -4879.7685546875,
        1064.4296875
      ],
      [
        -3109.1005859375,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3108.832763671875,
        -4765.30419921875,
        1081.5523681640625
      ],
      [
        -3105.112060546875,
        -4765.60791015625,
        1080.9447021484375
      ],
      [
        -3106.044921875,
        -4764.7685546875,
        1082.623779296875
      ],
      [
        -3223.03857421875,
        -4750.25830078125,
        1052.623779296875
      ],
      [
        -3223.016357421875,
        -4750.28173828125,
        1082.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3302.37060546875,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3308.169189453125,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3246.82861328125,
        -4801.291015625,
        1095.0
      ],
      [
        -3246.82861328125,
        -4801.291015625,
        1082.623779296875
      ],
      [
        -3181.799560546875,
        -4838.76220703125,
        1089.5079345703125
      ],
      [
        -3181.799560546875,
        -4838.76220703125,
        1082.623779296875
      ],
      [
        -3246.82861328125,
        -4801.291015625,
        1095.0
      ],
      [
        -3164.42626953125,
        -4797.34228515625,
        1095.0
      ],
      [
        -3166.544677734375,
        -4800.5126953125,
        1095.0
      ],
      [
        -3179.539794921875,
        -4827.40087890625,
        1091.0233154296875
      ],
      [
        -3179.53955078125,
        -4827.40087890625,
        1082.623779296875
      ],
      [
        -3246.834716796875,
        -4801.28759765625,
        1082.623779296875
      ],
      [
        -3240.928466796875,
        -4788.52783203125,
        1082.623779296875
      ],
      [
        -3241.18115234375,
        -4789.10205078125,
        1097.197998046875
      ],
      [
        -3241.18115234375,
        -4789.10205078125,
        1097.197998046875
      ],
      [
        -3270.059814453125,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3270.07763671875,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -3270.07763671875,
        -4850.7685546875,
        1082.70166015625
      ],
      [
        -3252.5615234375,
        -4813.40576171875,
        1098.623779296875
      ],
      [
        -3252.545654296875,
        -4813.37158203125,
        1098.623779296875
      ],
      [
        -3270.034423828125,
        -4850.7138671875,
        1098.61474609375
      ],
      [
        -3270.034423828125,
        -4850.71435546875,
        1098.61474609375
      ],
      [
        -3252.5615234375,
        -4813.40576171875,
        1098.623779296875
      ],
      [
        -3270.034423828125,
        -4850.7138671875,
        1098.61474609375
      ],
      [
        -3270.06005859375,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3270.059814453125,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3270.034423828125,
        -4850.71435546875,
        1098.61474609375
      ],
      [
        -3319.999755859375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3252.4248046875,
        -4813.11376953125,
        1098.53662109375
      ],
      [
        -3241.079345703125,
        -4788.87109375,
        1091.3328857421875
      ],
      [
        -3247.90869140625,
        -4787.7001953125,
        1094.623779296875
      ],
      [
        -3247.90869140625,
        -4786.7001953125,
        1094.623779296875
      ],
      [
        -3253.0908203125,
        -4787.7001953125,
        1094.623779296875
      ],
      [
        -3253.0908203125,
        -4786.7001953125,
        1094.623779296875
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1089.5960693359375
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1089.5960693359375
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1094.47607421875
      ],
      [
        -3319.999755859375,
        -4825.7685546875,
        1094.47607421875
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3290.547119140625,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -2920.0,
        -4954.5869140625,
        1227.393310546875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3214.99951171875,
        -4965.7685546875,
        1152.623779296875
      ],
      [
        -3212.747802734375,
        -4976.64208984375,
        1166.2159423828125
      ],
      [
        -2985.0,
        -4965.7685546875,
        1152.623779296875
      ],
      [
        -2987.251708984375,
        -4976.64208984375,
        1166.2159423828125
      ],
      [
        -3255.81689453125,
        -4912.5498046875,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3302.565185546875,
        -4855.56982421875,
        1213.0048828125
      ],
      [
        -3302.565185546875,
        -4912.111328125,
        1213.0048828125
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3302.565185546875,
        -4855.56982421875,
        1213.0048828125
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3699.999755859375,
        -4853.626953125,
        1198.05712890625
      ],
      [
        -3646.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3610.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3689.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3653.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3646.999755859375,
        -4817.2685546875,
        1052.623779296875
      ],
      [
        -3646.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3610.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3610.999755859375,
        -4817.2685546875,
        1052.623779296875
      ],
      [
        -3689.999755859375,
        -4817.2685546875,
        1052.623779296875
      ],
      [
        -3689.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3653.999755859375,
        -4819.7685546875,
        1062.623291015625
      ],
      [
        -3653.999755859375,
        -4817.2685546875,
        1052.623779296875
      ],
      [
        -3303.63720703125,
        -4969.7685546875,
        1302.623779296875
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3369.999755859375,
        -4917.0087890625,
        1302.623779296875
      ],
      [
        -3360.86962890625,
        -4912.603515625,
        1266.10302734375
      ],
      [
        -3347.175537109375,
        -4916.06201171875,
        1211.3270263671875
      ],
      [
        -3369.999755859375,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3351.867919921875,
        -4914.876953125,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4863.6513671875,
        1238.15380859375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3600.0,
        -4863.9697265625,
        1239.427978515625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3566.1171875,
        -4863.6513671875,
        1238.15380859375
      ],
      [
        -3600.0,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4906.9423828125,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3128.60009765625,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3070.100341796875,
        -4589.7685546875,
        1060.0
      ],
      [
        -3070.100341796875,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3151.214111328125,
        -4409.7685546875,
        1056.623779296875
      ],
      [
        -3151.214111328125,
        -4389.7685546875,
        1056.623779296875
      ],
      [
        -3179.740234375,
        -4309.7685546875,
        1084.9443359375
      ],
      [
        -3210.25927734375,
        -4309.7685546875,
        1084.9443359375
      ],
      [
        -3279.90576171875,
        -4281.93115234375,
        1077.5
      ],
      [
        -3274.800048828125,
        -4283.4892578125,
        1077.5
      ],
      [
        -3264.46923828125,
        -4288.404296875,
        1082.5
      ],
      [
        -3268.512939453125,
        -4285.408203125,
        1077.5
      ],
      [
        -3268.512939453125,
        -4285.408203125,
        1077.5
      ],
      [
        -3274.800048828125,
        -4277.16552734375,
        1077.5
      ],
      [
        -3271.22412109375,
        -4284.58056640625,
        1077.5
      ],
      [
        -3277.904052734375,
        -4282.5419921875,
        1077.5
      ],
      [
        -3382.3056640625,
        -4281.931640625,
        1077.5
      ],
      [
        -3377.200439453125,
        -4283.48974609375,
        1077.5
      ],
      [
        -3370.9130859375,
        -4285.40869140625,
        1077.5
      ],
      [
        -3366.869384765625,
        -4288.40478515625,
        1082.5
      ],
      [
        -3370.9130859375,
        -4285.40869140625,
        1077.5
      ],
      [
        -3377.199462890625,
        -4277.1650390625,
        1077.5
      ],
      [
        -3373.6240234375,
        -4284.5810546875,
        1077.5
      ],
      [
        -3380.30419921875,
        -4282.54248046875,
        1077.5
      ],
      [
        -3329.90576171875,
        -4359.931640625,
        1077.5
      ],
      [
        -3324.80078125,
        -4361.48974609375,
        1077.5
      ],
      [
        -3314.46923828125,
        -4366.404296875,
        1082.5
      ],
      [
        -3318.51318359375,
        -4363.40869140625,
        1077.5
      ],
      [
        -3318.51318359375,
        -4363.40869140625,
        1077.5
      ],
      [
        -3324.80029296875,
        -4355.166015625,
        1077.5
      ],
      [
        -3321.224365234375,
        -4362.5810546875,
        1077.5
      ],
      [
        -3327.904052734375,
        -4360.54248046875,
        1077.5
      ],
      [
        -3276.905517578125,
        -4302.65087890625,
        1096.5
      ],
      [
        -3294.702880859375,
        -4271.82470703125,
        1096.5
      ],
      [
        -3294.702880859375,
        -4271.82470703125,
        1093.5
      ],
      [
        -3276.905517578125,
        -4302.65087890625,
        1093.5
      ],
      [
        -3289.550048828125,
        -4280.75,
        1096.5
      ],
      [
        -3289.550048828125,
        -4280.75,
        1093.5
      ],
      [
        -3282.175048828125,
        -4267.97607421875,
        1093.5
      ],
      [
        -3282.175048828125,
        -4267.97607421875,
        1096.5
      ],
      [
        -3267.425048828125,
        -4293.52392578125,
        1096.5
      ],
      [
        -3267.425048828125,
        -4293.52392578125,
        1093.5
      ],
      [
        -3282.175048828125,
        -4293.52392578125,
        1093.5
      ],
      [
        -3282.175048828125,
        -4293.52392578125,
        1096.5
      ],
      [
        -3260.050048828125,
        -4280.75,
        1096.5
      ],
      [
        -3260.050048828125,
        -4280.75,
        1093.5
      ],
      [
        -3267.425048828125,
        -4293.52392578125,
        1093.5
      ],
      [
        -3267.425048828125,
        -4293.52392578125,
        1096.5
      ],
      [
        -3267.425048828125,
        -4267.97607421875,
        1096.5
      ],
      [
        -3267.425048828125,
        -4267.97607421875,
        1093.5
      ],
      [
        -3260.050048828125,
        -4280.75,
        1093.5
      ],
      [
        -3260.050048828125,
        -4280.75,
        1096.5
      ],
      [
        -3282.175048828125,
        -4267.97607421875,
        1096.5
      ],
      [
        -3282.175048828125,
        -4267.97607421875,
        1093.5
      ],
      [
        -3267.425048828125,
        -4267.97607421875,
        1093.5
      ],
      [
        -3267.425048828125,
        -4267.97607421875,
        1096.5
      ],
      [
        -3276.905517578125,
        -4302.65087890625,
        1096.5
      ],
      [
        -3276.905517578125,
        -4302.65087890625,
        1093.5
      ],
      [
        -3294.702880859375,
        -4271.82470703125,
        1096.5
      ],
      [
        -3294.702880859375,
        -4271.82470703125,
        1093.5
      ],
      [
        -3392.737548828125,
        -4264.95654296875,
        1093.5
      ],
      [
        -3392.737548828125,
        -4264.95654296875,
        1096.5
      ],
      [
        -3384.574951171875,
        -4293.52392578125,
        1096.5
      ],
      [
        -3384.574951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3391.949951171875,
        -4280.75,
        1093.5
      ],
      [
        -3391.949951171875,
        -4280.75,
        1096.5
      ],
      [
        -3362.449951171875,
        -4280.75,
        1096.5
      ],
      [
        -3362.449951171875,
        -4280.75,
        1093.5
      ],
      [
        -3369.824951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3369.824951171875,
        -4293.52392578125,
        1096.5
      ],
      [
        -3369.824951171875,
        -4293.52392578125,
        1096.5
      ],
      [
        -3369.824951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3384.574951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3384.574951171875,
        -4293.52392578125,
        1096.5
      ],
      [
        -3391.949951171875,
        -4280.75,
        1096.5
      ],
      [
        -3391.949951171875,
        -4280.75,
        1093.5
      ],
      [
        -3384.666748046875,
        -4268.13525390625,
        1093.5
      ],
      [
        -3384.666748046875,
        -4268.13525390625,
        1096.5
      ],
      [
        -3365.33837890625,
        -4275.7470703125,
        1093.5
      ],
      [
        -3362.449951171875,
        -4280.75,
        1093.5
      ],
      [
        -3362.449951171875,
        -4280.75,
        1096.5
      ],
      [
        -3365.33837890625,
        -4275.7470703125,
        1096.5
      ],
      [
        -3397.6630859375,
        -4288.51171875,
        1093.5
      ],
      [
        -3397.6630859375,
        -4288.51171875,
        1096.5
      ],
      [
        -3384.574951171875,
        -4267.97607421875,
        1096.5
      ],
      [
        -3384.574951171875,
        -4267.97607421875,
        1093.5
      ],
      [
        -3369.824951171875,
        -4267.97607421875,
        1093.5
      ],
      [
        -3369.824951171875,
        -4267.97607421875,
        1096.5
      ],
      [
        -3369.824951171875,
        -4267.97607421875,
        1096.5
      ],
      [
        -3369.824951171875,
        -4267.97607421875,
        1093.5
      ],
      [
        -3384.574951171875,
        -4267.97607421875,
        1093.5
      ],
      [
        -3384.574951171875,
        -4267.97607421875,
        1096.5
      ],
      [
        -3312.5,
        -4324.82080078125,
        1096.5
      ],
      [
        -3312.5,
        -4324.82080078125,
        1093.5
      ],
      [
        -3339.550048828125,
        -4358.75,
        1096.5
      ],
      [
        -3339.550048828125,
        -4358.75,
        1093.5
      ],
      [
        -3332.175048828125,
        -4345.97607421875,
        1093.5
      ],
      [
        -3332.175048828125,
        -4345.97607421875,
        1096.5
      ],
      [
        -3332.175048828125,
        -4371.52392578125,
        1096.5
      ],
      [
        -3332.175048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3339.550048828125,
        -4358.75,
        1093.5
      ],
      [
        -3339.550048828125,
        -4358.75,
        1096.5
      ],
      [
        -3310.050048828125,
        -4358.75,
        1096.5
      ],
      [
        -3310.050048828125,
        -4358.75,
        1093.5
      ],
      [
        -3317.425048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3317.425048828125,
        -4371.52392578125,
        1096.5
      ],
      [
        -3317.425048828125,
        -4345.97607421875,
        1096.5
      ],
      [
        -3317.425048828125,
        -4345.97607421875,
        1093.5
      ],
      [
        -3310.050048828125,
        -4358.75,
        1093.5
      ],
      [
        -3310.050048828125,
        -4358.75,
        1096.5
      ],
      [
        -3317.425048828125,
        -4371.52392578125,
        1096.5
      ],
      [
        -3317.425048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3332.175048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3332.175048828125,
        -4371.52392578125,
        1096.5
      ],
      [
        -3332.175048828125,
        -4345.97607421875,
        1096.5
      ],
      [
        -3332.175048828125,
        -4345.97607421875,
        1093.5
      ],
      [
        -3317.425048828125,
        -4345.97607421875,
        1093.5
      ],
      [
        -3317.425048828125,
        -4345.97607421875,
        1096.5
      ],
      [
        -3443.437744140625,
        -4481.39990234375,
        1093.0
      ],
      [
        -3443.75,
        -4481.39990234375,
        1093.62451171875
      ],
      [
        -3443.75,
        -4478.39990234375,
        1093.62451171875
      ],
      [
        -3443.437744140625,
        -4478.39990234375,
        1093.0
      ],
      [
        -3508.06005859375,
        -4484.86865234375,
        1065.623779296875
      ],
      [
        -3508.06005859375,
        -4474.66845703125,
        1065.623779296875
      ],
      [
        -3508.06005859375,
        -4474.66845703125,
        1065.623779296875
      ],
      [
        -3508.06005859375,
        -4474.66845703125,
        1052.623779296875
      ],
      [
        -3508.06005859375,
        -4484.86865234375,
        1052.623779296875
      ],
      [
        -3508.06005859375,
        -4484.86865234375,
        1065.623779296875
      ],
      [
        -3624.999755859375,
        -4306.68310546875,
        1054.7738037109375
      ],
      [
        -3632.999755859375,
        -4306.68310546875,
        1054.7738037109375
      ],
      [
        -3632.999755859375,
        -4653.2939453125,
        1054.7738037109375
      ],
      [
        -3624.999755859375,
        -4653.2939453125,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4299.18310546875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4299.18310546875,
        1054.7738037109375
      ],
      [
        -3675.999755859375,
        -4666.13134765625,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4666.13134765625,
        1054.7738037109375
      ],
      [
        -2182.125244140625,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -2214.77978515625,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -2182.12548828125,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3488.941650390625,
        -4910.29736328125,
        1302.623779296875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3939.26220703125,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -3556.305419921875,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3802.58349609375,
        -4310.9921875,
        1302.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3985.582763671875,
        -4213.58984375,
        1402.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -4007.749267578125,
        -4244.5771484375,
        1402.623779296875
      ],
      [
        -3835.11669921875,
        -4356.12060546875,
        1302.623779296875
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -3311.842041015625,
        -3619.7685546875,
        1402.623779296875
      ],
      [
        -3221.86962890625,
        -3820.217529296875,
        1302.623779296875
      ],
      [
        -3239.638916015625,
        -4906.36181640625,
        1315.92041015625
      ],
      [
        -3248.5048828125,
        -4879.76904296875,
        1302.6241455078125
      ],
      [
        -3100.0,
        -3780.262451171875,
        1322.556640625
      ],
      [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3515.0,
      "bbox_min": [
        -4086.999755859375,
        -4675.39990234375,
        982.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -3890.92822265625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4342.63525390625,
        1012.623779296875
      ],
      "bbox_max": [
        -3230.814453125,
        -3890.92822265625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3412.375244140625,
        -4342.63525390625,
        1012.623779296875
      ],
      "bbox_max": [
        -3230.814453125,
        -3890.92822265625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5178.83251953125,
      "bbox_min": [
        -3412.375244140625,
        -4342.63525390625,
        1032.623779296875
      ],
      "bbox_max": [
        -3234.2998046875,
        -4057.72998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3123.67578125,
      "bbox_min": [
        -3412.375244140625,
        -4342.63525390625,
        1051.3370361328125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -3960.58642578125,
      "bbox_min": [
        -3412.375244140625,
        -4342.63525390625,
        1051.3370361328125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6564568281173706,
        0.37900400161743164,
        0.6522426605224609
      ],
      "plane_d": -1310.300048828125,
      "bbox_min": [
        -3412.375244140625,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1333.422607421875,
      "bbox_min": [
        -3412.375244140625,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4472.3642578125,
      "bbox_min": [
        -3412.375244140625,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3407.68359375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5490.81103515625,
      "bbox_min": [
        -3409.46533203125,
        -4260.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3407.68359375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.652239978313446,
        -0.7580124735832214
      ],
      "plane_d": 3613.9052734375,
      "bbox_min": [
        -3380.1875,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232287406921387,
        0.21362555027008057,
        -0.3193947374820709
      ],
      "plane_d": -1861.7857666015625,
      "bbox_min": [
        -3380.1875,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3374.21240234375,
        -4317.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4374.06884765625,
      "bbox_min": [
        -3374.727294921875,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3374.21240234375,
        -4317.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2481.8486328125,
      "bbox_min": [
        -3346.71630859375,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2604.05419921875,
      "bbox_min": [
        -3346.71630859375,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6466192007064819,
        0.6927235722541809,
        -0.3194020688533783
      ],
      "plane_d": 1123.286865234375,
      "bbox_min": [
        -3346.71630859375,
        -4260.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3344.9345703125,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6564568281173706,
        0.37900400161743164,
        0.6522426605224609
      ],
      "plane_d": -1246.33935546875,
      "bbox_min": [
        -3359.975341796875,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3355.28369140625,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1278.38671875,
      "bbox_min": [
        -3359.975341796875,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3355.28369140625,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4528.5654296875,
      "bbox_min": [
        -3359.975341796875,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3355.28369140625,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5510.96142578125,
      "bbox_min": [
        -3357.0654296875,
        -4338.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3355.28369140625,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -3960.58642578125,
      "bbox_min": [
        -3309.975341796875,
        -4342.63525390625,
        1051.3370361328125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3056.454833984375,
      "bbox_min": [
        -3309.975341796875,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6564568281173706,
        0.37900400161743164,
        0.6522426605224609
      ],
      "plane_d": -1243.078857421875,
      "bbox_min": [
        -3309.975341796875,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1275.581298828125,
      "bbox_min": [
        -3309.975341796875,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4444.03955078125,
      "bbox_min": [
        -3309.975341796875,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3305.28369140625,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5424.59765625,
      "bbox_min": [
        -3307.0654296875,
        -4260.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3305.28369140625,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.652239978313446,
        -0.7580124735832214
      ],
      "plane_d": 3613.9052734375,
      "bbox_min": [
        -3277.78759765625,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232287406921387,
        0.21362555027008057,
        -0.3193947374820709
      ],
      "plane_d": -1767.2471923828125,
      "bbox_min": [
        -3277.78759765625,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3271.8125,
        -4317.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4279.5302734375,
      "bbox_min": [
        -3272.327392578125,
        -4319.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3271.8125,
        -4317.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2424.00732421875,
      "bbox_min": [
        -3244.31640625,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2632.378662109375,
      "bbox_min": [
        -3244.31640625,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3239.624755859375,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6466192007064819,
        0.6927235722541809,
        -0.3194020688533783
      ],
      "plane_d": 1189.50048828125,
      "bbox_min": [
        -3244.31640625,
        -4260.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3242.53466796875,
        -4258.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3118.83984375,
      "bbox_min": [
        -3294.31640625,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2477.6875,
      "bbox_min": [
        -3294.31640625,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2689.243896484375,
      "bbox_min": [
        -3294.31640625,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6466192007064819,
        0.6927235722541809,
        -0.3194020688533783
      ],
      "plane_d": 1211.201904296875,
      "bbox_min": [
        -3294.31640625,
        -4338.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3292.53466796875,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4389.7685546875,
      "bbox_min": [
        -3327.78759765625,
        -4589.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3020.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3094.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1051.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3104.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3104.0,
        -4377.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -3327.78759765625,
        -4589.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3020.999755859375,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.00015022426669020206
      ],
      "plane_d": -3092.34375,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3102.499755859375,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4244791865348816,
        0.905437707901001
      ],
      "plane_d": 978.1386108398438,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4519.7685546875,
        1048.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1048.0
      ],
      "bbox_max": [
        -3020.999755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3102.499755859375,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1048.0
      ],
      "bbox_max": [
        -3102.499755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3327.78759765625,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46166881918907166,
        0.0,
        0.8870524168014526
      ],
      "plane_d": 523.0634155273438,
      "bbox_min": [
        -3327.78759765625,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -4019.711181640625,
      "bbox_min": [
        -3327.78759765625,
        -4397.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3321.8125,
        -4395.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.652239978313446,
        -0.7580124735832214
      ],
      "plane_d": 3664.77978515625,
      "bbox_min": [
        -3327.78759765625,
        -4397.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3321.8125,
        -4395.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232287406921387,
        0.21362555027008057,
        -0.3193947374820709
      ],
      "plane_d": -1796.7457275390625,
      "bbox_min": [
        -3327.78759765625,
        -4397.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3321.8125,
        -4395.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4342.3544921875,
      "bbox_min": [
        -3322.327392578125,
        -4397.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3321.8125,
        -4395.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4616886377334595,
        0.0,
        0.8870421648025513
      ],
      "plane_d": -2338.7333984375,
      "bbox_min": [
        -3070.10009765625,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3784.999755859375,
      "bbox_min": [
        -4086.999755859375,
        -4675.39990234375,
        982.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.623779296875,
      "bbox_min": [
        -4086.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4439.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4539.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4539.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4499.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": 1131.5269775390625,
      "bbox_min": [
        -3886.999755859375,
        -4499.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3836.999755859375,
        -4439.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": 1131.5269775390625,
      "bbox_min": [
        -3886.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -982.623779296875,
      "bbox_min": [
        -3836.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        982.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": 1131.5269775390625,
      "bbox_min": [
        -3886.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -982.623779296875,
      "bbox_min": [
        -3836.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4499.7685546875,
        982.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.5999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        982.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1002.5999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        982.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -982.623779296875,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1000.623779296875,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3754.999755859375,
      "bbox_min": [
        -3754.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3742.999755859375,
      "bbox_min": [
        -3754.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -3754.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -3754.999755859375,
        -4439.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -3754.999755859375,
        -4399.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4539.7685546875,
      "bbox_min": [
        -3754.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4539.7685546875,
        1002.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3742.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1000.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1000.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1000.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4399.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1000.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4539.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4488.107421875,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4472.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4488.107421875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3659.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -3699.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1022.623779296875,
      "bbox_min": [
        -3699.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4480.7685546875,
      "bbox_min": [
        -3699.999755859375,
        -4480.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4289.7998046875,
      "bbox_min": [
        -3784.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4144425392150879,
        -0.9100755453109741,
        -0.0
      ],
      "plane_d": -5421.30859375,
      "bbox_min": [
        -3784.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3684.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.789697527885437,
        -0.6134963631629944,
        0.0
      ],
      "plane_d": 308.167724609375,
      "bbox_min": [
        -3784.999755859375,
        -4369.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6876122951507568,
        -0.7260780930519104,
        0.0
      ],
      "plane_d": -5683.3466796875,
      "bbox_min": [
        -3728.17138671875,
        -4337.68212890625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6885915398597717,
        0.7251494526863098,
        0.0
      ],
      "plane_d": 5662.794921875,
      "bbox_min": [
        -3706.1865234375,
        -4309.91845703125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3617.999755859375,
      "bbox_min": [
        -3684.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4309.91845703125,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6885899901390076,
        0.7251508831977844,
        0.0
      ],
      "plane_d": 5662.794921875,
      "bbox_min": [
        -3617.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4322.6318359375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872271299362183,
        -0.7264425754547119,
        -0.0
      ],
      "plane_d": -5683.5087890625,
      "bbox_min": [
        -3617.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3561.76171875,
        -4401.06494140625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9301810264587402,
        0.36710113286972046,
        0.0
      ],
      "plane_d": -1677.9166259765625,
      "bbox_min": [
        -3569.063232421875,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3561.76171875,
        -4454.267578125,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6528502106666565,
        -0.7574871778488159,
        0.0
      ],
      "plane_d": -5617.3427734375,
      "bbox_min": [
        -3588.8857421875,
        -4439.87353515625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4322.6318359375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8647767305374146,
        -0.5021565556526184,
        0.0
      ],
      "plane_d": -5254.2734375,
      "bbox_min": [
        -3548.144775390625,
        -4439.87353515625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4362.4326171875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2895314693450928,
        0.9571685194969177,
        0.0
      ],
      "plane_d": 3222.407470703125,
      "bbox_min": [
        -3548.144775390625,
        -4439.87353515625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4429.84765625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.623779296875,
      "bbox_min": [
        -3684.999755859375,
        -4401.0654296875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3617.999755859375,
        -4309.91845703125,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        -0.7264418005943298,
        0.00011730521509889513
      ],
      "plane_d": -5683.62646484375,
      "bbox_min": [
        -3684.999755859375,
        -4401.0654296875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3617.999755859375,
        -4337.681640625,
        1005.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3684.999755859375,
        -4401.0654296875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3617.999755859375,
        -4309.91845703125,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        -0.7264418005943298,
        -7.128093420760706e-05
      ],
      "plane_d": -5683.43505859375,
      "bbox_min": [
        -3684.999755859375,
        -4401.0654296875,
        1027.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4309.91845703125,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6885905861854553,
        0.7251503467559814,
        0.0
      ],
      "plane_d": 5662.794921875,
      "bbox_min": [
        -3684.999755859375,
        -4373.54052734375,
        1027.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4309.91845703125,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3671.062255859375,
        -4318.46484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3675.711181640625,
        -4318.46484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3917.63671875,
      "bbox_min": [
        -3675.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4318.46484375,
        1027.9342041015625
      ],
      "bbox_max": [
        -3675.999755859375,
        -4314.34521484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3923.259033203125,
      "bbox_min": [
        -3632.999755859375,
        -4347.216796875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4347.216796875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3632.999755859375,
        -4347.216796875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.17327415943145752,
        -0.9848736524581909
      ],
      "plane_d": 241.859130859375,
      "bbox_min": [
        -3632.999755859375,
        -4346.03955078125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4342.21875,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9879216551780701,
        -0.15495389699935913,
        -0.0
      ],
      "plane_d": -4261.962890625,
      "bbox_min": [
        -3632.999755859375,
        -4346.03955078125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3632.400390625,
        -4342.21875,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.17327415943145752,
        -0.9848736524581909
      ],
      "plane_d": 241.859130859375,
      "bbox_min": [
        -3632.999755859375,
        -4347.216796875,
        1010.196044921875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4342.21875,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.981459379196167,
        -0.19167031347751617,
        0.0
      ],
      "plane_d": 2725.515625,
      "bbox_min": [
        -3632.999755859375,
        -4347.216796875,
        1010.196044921875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4342.21875,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3677.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3667.999755859375,
        -4318.73876953125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3667.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.23319560289382935,
        -0.9724298715591431
      ],
      "plane_d": 1992.5284423828125,
      "bbox_min": [
        -3675.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3667.999755859375,
        -4334.71875,
        1009.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4339.71875,
      "bbox_min": [
        -3675.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3667.999755859375,
        -4339.71875,
        1008.8607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4339.71875,
      "bbox_min": [
        -3675.999755859375,
        -4339.71875,
        1008.8607177734375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4334.71875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.22986893355846405,
        0.9732215404510498
      ],
      "plane_d": 9.06072998046875,
      "bbox_min": [
        -3675.999755859375,
        -4339.71875,
        1014.5238037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4334.71875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.3713906705379486,
        0.0
      ],
      "plane_d": -1803.2059326171875,
      "bbox_min": [
        -3677.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3675.999755859375,
        -4334.71875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4339.71875,
      "bbox_min": [
        -3677.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3675.999755859375,
        -4334.71875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.22986893355846405,
        0.9732215404510498
      ],
      "plane_d": 9.06072998046875,
      "bbox_min": [
        -3677.999755859375,
        -4339.71875,
        1014.5238037109375
      ],
      "bbox_max": [
        -3675.999755859375,
        -4334.71875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.23319560289382935,
        -0.9724298715591431
      ],
      "plane_d": 1992.5284423828125,
      "bbox_min": [
        -3667.999755859375,
        -4339.71875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3665.999755859375,
        -4334.71875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3026682138442993,
        0.9530960321426392,
        0.0
      ],
      "plane_d": 3348.042236328125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3684.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9600293636322021,
        0.2798992693424225,
        -0.0
      ],
      "plane_d": 4907.18798828125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4549.7685546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872249841690063,
        0.726444661617279,
        0.0
      ],
      "plane_d": 825.824951171875,
      "bbox_min": [
        -3750.459716796875,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4622.85546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14052800834178925,
        0.9900767803192139,
        0.0
      ],
      "plane_d": 5148.95849609375,
      "bbox_min": [
        -3735.253173828125,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4650.13134765625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872240304946899,
        -0.7264456152915955,
        0.0
      ],
      "plane_d": -845.647216796875,
      "bbox_min": [
        -3710.159423828125,
        -4673.9326171875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3684.999755859375,
        -4650.13134765625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14052800834178925,
        0.9900767803192139,
        0.0
      ],
      "plane_d": 5148.95849609375,
      "bbox_min": [
        -3750.459716796875,
        -4670.39599609375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3735.253173828125,
        -4668.23779296875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3617.999755859375,
      "bbox_min": [
        -3684.999755859375,
        -4652.5048828125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6872284412384033,
        -0.7264413833618164,
        0.0
      ],
      "plane_d": -845.611328125,
      "bbox_min": [
        -3617.999755859375,
        -4652.5048828125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872289776802063,
        0.726440966129303,
        0.0
      ],
      "plane_d": 825.793212890625,
      "bbox_min": [
        -3617.999755859375,
        -4559.47216796875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3561.761474609375,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9278250336647034,
        -0.37301579117774963,
        -0.0
      ],
      "plane_d": -4985.60107421875,
      "bbox_min": [
        -3569.063232421875,
        -4506.26953125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3561.761474609375,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7406286001205444,
        0.6719146966934204,
        0.0
      ],
      "plane_d": 468.054931640625,
      "bbox_min": [
        -3588.8857421875,
        -4652.5048828125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4520.66357421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8568736910820007,
        0.5155263543128967,
        0.0
      ],
      "plane_d": -663.69287109375,
      "bbox_min": [
        -3548.14453125,
        -4602.70458984375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4520.66357421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28953343629837036,
        -0.9571679830551147,
        -0.0
      ],
      "plane_d": -5354.34130859375,
      "bbox_min": [
        -3548.14453125,
        -4530.689453125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4520.66357421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.623779296875,
      "bbox_min": [
        -3684.999755859375,
        -4651.576171875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        0.7264418005943298,
        0.0
      ],
      "plane_d": 825.80029296875,
      "bbox_min": [
        -3684.999755859375,
        -4650.13134765625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1005.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872280240058899,
        -0.7264418005943298,
        0.0
      ],
      "plane_d": -845.61474609375,
      "bbox_min": [
        -3684.999755859375,
        -4650.13134765625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3617.999755859375,
        -4586.748046875,
        1005.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3677.999755859375,
        -4632.0185546875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3650.999755859375,
        -4616.06787109375,
        1029.413818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872280240058899,
        -0.7264418005943298,
        0.0
      ],
      "plane_d": -845.61474609375,
      "bbox_min": [
        -3665.853271484375,
        -4632.0185546875,
        1027.623779296875
      ],
      "bbox_max": [
        -3650.999755859375,
        -4617.966796875,
        1029.413818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4627.0185546875,
      "bbox_min": [
        -3677.999755859375,
        -4632.0185546875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3665.999755859375,
        -4627.0185546875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.23319560289382935,
        -0.9724298715591431
      ],
      "plane_d": -98.47528076171875,
      "bbox_min": [
        -3677.999755859375,
        -4632.0185546875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3665.999755859375,
        -4627.0185546875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22986893355846405,
        0.9732215404510498
      ],
      "plane_d": -2052.11376953125,
      "bbox_min": [
        -3677.999755859375,
        -4632.0185546875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3665.999755859375,
        -4627.0185546875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.3713906705379486,
        0.0
      ],
      "plane_d": 1685.3638916015625,
      "bbox_min": [
        -3677.999755859375,
        -4632.0185546875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3665.999755859375,
        -4627.0185546875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        -0.3713906705379486,
        0.0
      ],
      "plane_d": -5133.36865234375,
      "bbox_min": [
        -3677.999755859375,
        -4632.0185546875,
        1008.3247680664062
      ],
      "bbox_max": [
        -3675.999755859375,
        -4627.0185546875,
        1015.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.762873649597168,
        -0.6465476155281067
      ],
      "plane_d": -2880.939697265625,
      "bbox_min": [
        -3684.999755859375,
        -4651.576171875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3665.853271484375,
        -4632.0185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3684.82568359375,
        -4651.576171875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3665.853271484375,
        -4632.0185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3684.82568359375,
        -4651.576171875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4632.0185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4647.33837890625,
        1014.5238037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4632.0185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872280240058899,
        -0.7264418005943298,
        0.0
      ],
      "plane_d": -845.61474609375,
      "bbox_min": [
        -3675.999755859375,
        -4641.6171875,
        1027.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4632.0185546875,
        1029.586181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3675.999755859375,
        -4641.6171875,
        1027.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4632.0185546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3684.82568359375,
        -4649.13623046875,
        1027.623779296875
      ],
      "bbox_max": [
        -3675.999755859375,
        -4639.19384765625,
        1029.72119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872280240058899,
        -0.7264418005943298,
        0.0
      ],
      "plane_d": -845.61474609375,
      "bbox_min": [
        -3683.94775390625,
        -4649.13623046875,
        1027.623779296875
      ],
      "bbox_max": [
        -3675.999755859375,
        -4641.6171875,
        1029.72119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872280240058899,
        -0.7264418005943298,
        0.0
      ],
      "plane_d": -845.61474609375,
      "bbox_min": [
        -3667.999755859375,
        -4634.04931640625,
        1027.623779296875
      ],
      "bbox_max": [
        -3665.853271484375,
        -4632.0185546875,
        1029.4503173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3667.999755859375,
        -4634.04931640625,
        1027.623779296875
      ],
      "bbox_max": [
        -3665.853271484375,
        -4632.0185546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3650.999755859375,
        -4617.966796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4585.541015625,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4619.5205078125,
      "bbox_min": [
        -3632.999755859375,
        -4624.5185546875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4619.5205078125,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9814593195915222,
        0.19167029857635498,
        0.0
      ],
      "plane_d": 4444.1728515625,
      "bbox_min": [
        -3632.999755859375,
        -4624.5185546875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4619.5205078125,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9879217147827148,
        0.15495391190052032,
        0.0
      ],
      "plane_d": -2872.5322265625,
      "bbox_min": [
        -3632.999755859375,
        -4624.5185546875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3632.2158203125,
        -4619.5205078125,
        1014.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4641.01611328125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3624.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4641.01611328125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4641.01611328125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4637.44140625,
        1014.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3684.999755859375,
        -4650.13134765625,
        1027.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        0.7264418005943298,
        0.0
      ],
      "plane_d": 825.80029296875,
      "bbox_min": [
        -3684.999755859375,
        -4650.13134765625,
        1027.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6872280240058899,
        -0.7264418005943298,
        0.0
      ],
      "plane_d": -845.61474609375,
      "bbox_min": [
        -3684.999755859375,
        -4650.13134765625,
        1028.60107421875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4586.748046875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4289.7998046875,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3026682138442993,
        0.9530960321426392,
        0.0
      ],
      "plane_d": 3348.042236328125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4675.39990234375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600293636322021,
        0.2798992693424225,
        -0.0
      ],
      "plane_d": 4907.18798828125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.789697527885437,
        -0.6134963631629944,
        0.0
      ],
      "plane_d": 308.167724609375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6528502702713013,
        -0.7574871182441711,
        -0.0
      ],
      "plane_d": -5617.3427734375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7406286001205444,
        0.6719146966934204,
        0.0
      ],
      "plane_d": 468.054931640625,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14052800834178925,
        0.9900767803192139,
        -0.0
      ],
      "plane_d": 5148.95849609375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4144425392150879,
        -0.9100755453109741,
        -0.0
      ],
      "plane_d": -5421.30859375,
      "bbox_min": [
        -3784.999755859375,
        -4673.9326171875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3923.259033203125,
      "bbox_min": [
        -3629.4326171875,
        -4306.18603515625,
        1050.3369140625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8647767305374146,
        -0.5021565556526184,
        0.0
      ],
      "plane_d": -5254.2734375,
      "bbox_min": [
        -3784.999755859375,
        -4673.9326171875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3784.999755859375,
        -4673.9326171875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6872274279594421,
        0.7264423370361328,
        0.0
      ],
      "plane_d": 825.8046875,
      "bbox_min": [
        -3784.999755859375,
        -4673.9326171875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872275471687317,
        -0.7264422178268433,
        0.0
      ],
      "plane_d": -845.618408203125,
      "bbox_min": [
        -3710.159423828125,
        -4673.9326171875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4520.66357421875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28953343629837036,
        -0.9571679830551147,
        -0.0
      ],
      "plane_d": -5354.34130859375,
      "bbox_min": [
        -3675.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4520.66357421875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.762873649597168,
        -0.6465476155281067
      ],
      "plane_d": -2880.939697265625,
      "bbox_min": [
        -3675.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4647.33837890625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4647.33837890625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3675.999755859375,
        -4647.33837890625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4645.32275390625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4645.32275390625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4645.32275390625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3624.99951171875,
      "bbox_min": [
        -3624.999755859375,
        -4645.32275390625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.687326967716217,
        -0.7263482213020325,
        0.0
      ],
      "plane_d": -5683.4443359375,
      "bbox_min": [
        -3784.999755859375,
        -4506.26953125,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6885904669761658,
        0.7251505255699158,
        0.0
      ],
      "plane_d": 5662.79541015625,
      "bbox_min": [
        -3706.1865234375,
        -4439.87353515625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3675.689208984375,
        -4318.46484375,
        1032.9339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3923.259033203125,
      "bbox_min": [
        -3675.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3632.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4316.52685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3917.63671875,
      "bbox_min": [
        -3675.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4318.46484375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3675.999755859375,
        -4309.02685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9301810264587402,
        0.36710113286972046,
        0.0
      ],
      "plane_d": -1677.9166259765625,
      "bbox_min": [
        -3569.063232421875,
        -4472.7685546875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3561.76171875,
        -4454.267578125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9278250336647034,
        -0.37301579117774963,
        0.0
      ],
      "plane_d": -4985.60107421875,
      "bbox_min": [
        -3569.063232421875,
        -4506.26953125,
        1032.5999755859375
      ],
      "bbox_max": [
        -3561.761474609375,
        -4488.107421875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.36865234375,
      "bbox_min": [
        -3675.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4459.2001953125,
      "bbox_min": [
        -3675.999755859375,
        -4499.36865234375,
        1038.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1050.623779296875,
      "bbox_min": [
        -3539.999755859375,
        -4499.36865234375,
        1050.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4459.2001953125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3539.999755859375,
      "bbox_min": [
        -3539.999755859375,
        -4499.36865234375,
        1050.623779296875
      ],
      "bbox_max": [
        -3539.999755859375,
        -4459.2001953125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.64853835105896,
        0.7611821293830872
      ],
      "plane_d": 2090.72412109375,
      "bbox_min": [
        -3675.999755859375,
        -4459.2001953125,
        1038.623779296875
      ],
      "bbox_max": [
        -3529.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6393550038337708,
        -0.7689118385314941
      ],
      "plane_d": -2043.1749267578125,
      "bbox_min": [
        -3539.999755859375,
        -4459.2001953125,
        1038.623779296875
      ],
      "bbox_max": [
        -3529.999755859375,
        -4442.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3539.999755859375,
      "bbox_min": [
        -3539.999755859375,
        -4459.2001953125,
        1038.623779296875
      ],
      "bbox_max": [
        -3529.999755859375,
        -4442.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3529.99951171875,
      "bbox_min": [
        -3529.999755859375,
        -4459.2001953125,
        1038.623779296875
      ],
      "bbox_max": [
        -3529.999755859375,
        -4442.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3917.63671875,
      "bbox_min": [
        -3675.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4313.44140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3675.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3632.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4320.94140625,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4306.18603515625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3529.999755859375,
      "bbox_min": [
        -3539.999755859375,
        -4515.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3529.999755859375,
        -4499.3681640625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -3539.99951171875,
      "bbox_min": [
        -3539.999755859375,
        -4515.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3539.999755859375,
        -4499.36865234375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.762873649597168,
        -0.6465476155281067
      ],
      "plane_d": -2880.939697265625,
      "bbox_min": [
        -3675.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4652.44384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4652.44384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3675.999755859375,
        -4652.44384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4655.33154296875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4655.33154296875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4655.33154296875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3624.99951171875,
      "bbox_min": [
        -3624.999755859375,
        -4655.33154296875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4249.7685546875,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -3820.217529296875,
        1302.6241455078125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -232.342041015625,
      "bbox_min": [
        -2705.536865234375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2310.823486328125,
        -3984.21875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        -0.8660249710083008,
        1.395172148477286e-06
      ],
      "plane_d": -4776.0458984375,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2310.823486328125,
        -4020.00439453125,
        1226.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2310.823486328125,
        -4065.557373046875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2484.04052734375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2310.823486328125,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2341.7802734375,
        -4229.22412109375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2484.04052734375,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.97412109375,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2393.97412109375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.428466796875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000013709068298,
        -0.8660246729850769,
        -0.0
      ],
      "plane_d": -4812.044921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44329512119293213,
        -0.7678069472312927,
        -0.46256038546562195
      ],
      "plane_d": -3709.5517578125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1203.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999839067459106,
        -0.8660262823104858,
        0.0
      ],
      "plane_d": -4828.6435546875,
      "bbox_min": [
        -2615.537109375,
        -4072.557373046875,
        1101.623779296875
      ],
      "bbox_max": [
        -2603.412353515625,
        -4065.557373046875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2662.0029296875,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3984.21875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7492340207099915,
        0.4325691759586334,
        0.5015299916267395
      ],
      "plane_d": -780.37060546875,
      "bbox_min": [
        -2662.0029296875,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3993.17724609375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1121.623779296875,
      "bbox_min": [
        -2642.42333984375,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -4010.27880859375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660218715667725,
        0.5000061392784119,
        0.0
      ],
      "plane_d": -250.7601318359375,
      "bbox_min": [
        -2642.42333984375,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.659912109375,
        -4040.0830078125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2637.016357421875,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.659912109375,
        -4040.0830078125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2603.659912109375,
        -4040.0830078125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999839067459106,
        -0.8660262823104858,
        0.0
      ],
      "plane_d": -4828.6435546875,
      "bbox_min": [
        -2617.66015625,
        -4065.557373046875,
        1101.623779296875
      ],
      "bbox_max": [
        -2615.536865234375,
        -4064.33154296875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999839067459106,
        -0.8660262823104858,
        0.0
      ],
      "plane_d": -4828.6435546875,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1101.623779296875
      ],
      "bbox_max": [
        -2617.66015625,
        -4061.83154296875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1113.623779296875,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1113.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4061.83154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2637.016357421875,
        -4071.357666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.33154296875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000026226043701,
        -0.8660238981246948,
        2.5891913537634537e-05
      ],
      "plane_d": -4828.673828125,
      "bbox_min": [
        -2637.016357421875,
        -4071.357666015625,
        1101.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.33154296875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1113.623779296875,
      "bbox_min": [
        -2637.016357421875,
        -4071.357666015625,
        1113.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.33154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000001788139343,
        -0.8660252690315247,
        -6.3212073655449785e-06
      ],
      "plane_d": -4828.6376953125,
      "bbox_min": [
        -2642.42333984375,
        -4056.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2631.516357421875,
        -4050.034423828125,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3600.0,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        7.751265229671844e-07,
        0.0
      ],
      "plane_d": -3046.496826171875,
      "bbox_min": [
        -3600.0,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1121.623779296875,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2772.9892578125,
        -3925.654541015625,
        1082.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9836496710777283,
        0.18009302020072937,
        0.0
      ],
      "plane_d": -2000.666015625,
      "bbox_min": [
        -2752.65576171875,
        -3925.654541015625,
        1082.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3918.51513671875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -3003.1396484375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -3903.140869140625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -3003.1396484375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -3998.117919921875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3003.1396484375,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3998.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2725.0498046875,
      "bbox_min": [
        -2939.89990234375,
        -4054.818603515625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3998.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2939.89990234375,
        -4051.66845703125,
        1106.623779296875
      ],
      "bbox_max": [
        -2760.61865234375,
        -3998.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375558018684387,
        -0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": -4361.27197265625,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2760.61865234375,
        -4002.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4004.4853515625,
      "bbox_min": [
        -2791.1904296875,
        -4037.419189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2760.61865234375,
        -4002.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426049113273621,
        0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -899.3235473632812,
      "bbox_min": [
        -2781.899658203125,
        -4037.419189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2760.61865234375,
        -4002.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426109313964844,
        -0.42874401807785034,
        0.5144973993301392
      ],
      "plane_d": -4346.216796875,
      "bbox_min": [
        -2781.899658203125,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2760.61865234375,
        -4002.117919921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2781.899658203125,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4018.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2781.899658203125,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.716552734375,
        -4018.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2939.89990234375,
        -4051.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2854.599853515625,
        -4018.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2939.89990234375,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2939.716796875,
        -4018.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4066.316650390625,
      "bbox_min": [
        -2856.39990234375,
        -4051.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2854.599853515625,
        -4049.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2871.166748046875,
      "bbox_min": [
        -2856.39990234375,
        -4051.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2856.216796875,
        -4049.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2939.89990234375,
        -4103.4189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4080.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4074.689453125,
      "bbox_min": [
        -2793.499755859375,
        -4103.4189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4080.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2781.899658203125,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4080.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2781.899658203125,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.716552734375,
        -4080.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2939.89990234375,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4080.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2939.89990234375,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2939.716796875,
        -4080.86865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -4082.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -2772.9892578125,
        -3925.654541015625,
        1121.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9836496710777283,
        0.18009302020072937,
        0.0
      ],
      "plane_d": -2000.666015625,
      "bbox_min": [
        -2752.65576171875,
        -3925.654541015625,
        1121.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3918.51513671875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4050.7685546875,
      "bbox_min": [
        -3008.0888671875,
        -4082.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.455078125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2723.999755859375,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -2250.0205078125,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2723.999755859375,
        -4019.0517578125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2939.499755859375,
        -4019.0517578125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        -0.0
      ],
      "plane_d": -4843.7958984375,
      "bbox_min": [
        -2939.716796875,
        -4050.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2723.999755859375,
        -4019.0517578125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2781.716552734375,
        -4048.234375,
        1121.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4019.0517578125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2725.0498046875,
      "bbox_min": [
        -2725.0498046875,
        -4048.234375,
        1121.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4046.718505859375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2939.716796875,
        -4020.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2939.499755859375,
        -4020.02294921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2725.0498046875,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4048.234375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -4970.70166015625,
      "bbox_min": [
        -3008.0888671875,
        -4082.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.455078125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2939.716796875,
        -4082.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.455078125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2781.716552734375,
        -4082.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.455078125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -2730.0888671875,
        -4058.64013671875,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.455078125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": -4389.66455078125,
      "bbox_min": [
        -2730.0888671875,
        -4058.64013671875,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -2725.0498046875,
        -4054.818603515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4066.316650390625,
      "bbox_min": [
        -2939.716796875,
        -4081.514404296875,
        1121.623779296875
      ],
      "bbox_max": [
        -2854.782958984375,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2871.166748046875,
      "bbox_min": [
        -2856.216796875,
        -4051.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2855.999755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2939.716796875,
        -4081.514404296875,
        1121.623779296875
      ],
      "bbox_max": [
        -2939.499755859375,
        -4081.0517578125,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2939.716796875,
        -4082.4853515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2938.282958984375,
        -4082.2685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -3008.0888671875,
        -4058.64013671875,
        1121.623779296875
      ],
      "bbox_max": [
        -2994.455078125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        -0.4999813139438629,
        -0.0
      ],
      "plane_d": -4630.42236328125,
      "bbox_min": [
        -3008.0888671875,
        -4058.64013671875,
        1121.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1121.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3003.1396484375,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1121.623779296875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -3759.938232421875,
      "bbox_min": [
        -3600.0,
        -4190.0830078125,
        1052.623779296875
      ],
      "bbox_max": [
        -3293.08740234375,
        -3890.92822265625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4032.349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3293.08740234375,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3899.365966796875,
        1052.623779296875
      ],
      "bbox_max": [
        -3293.08740234375,
        -3890.92822265625,
        1100.8765869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4264.18798828125,
      "bbox_min": [
        -3600.0,
        -4119.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4032.349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3292.686279296875,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3301.525146484375,
        -4020.172607421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6787002682685852,
        -0.6787002682685852,
        0.2805918753147125
      ],
      "plane_d": -5190.9072265625,
      "bbox_min": [
        -3301.525146484375,
        -3984.973388671875,
        1052.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3301.525146484375,
        -3984.973388671875,
        1052.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3984.973388671875,
        1052.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3887.0,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.5,
      "bbox_min": [
        -3288.898193359375,
        -3960.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3108.0,
        -3887.0,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.5999755859375,
      "bbox_min": [
        -3288.898193359375,
        -3913.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3268.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888453006744385,
        -0.6145919561386108,
        0.0
      ],
      "plane_d": 195.33837890625,
      "bbox_min": [
        -3288.898193359375,
        -3903.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3276.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3160.0,
        -3960.0,
        1080.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3937.5,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3160.0,
        -3960.0,
        1087.6878662109375
      ],
      "bbox_max": [
        -3126.57080078125,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1096.487548828125
      ],
      "bbox_max": [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3160.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3126.57080078125,
        -3937.5,
        1100.4039306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.5999755859375,
      "bbox_min": [
        -3160.0,
        -3950.0,
        1096.5999755859375
      ],
      "bbox_max": [
        -3150.0,
        -3937.5,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3149.70458984375,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6224409937858582,
        -0.7379052639007568,
        0.2608889639377594
      ],
      "plane_d": -5213.8037109375,
      "bbox_min": [
        -3301.525146484375,
        -3890.92822265625,
        1102.623779296875
      ],
      "bbox_max": [
        -3224.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3207.47998046875,
        -4020.172607421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3207.47998046875,
        -4020.172607421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3941.97265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3207.47998046875,
        -4020.172607421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3941.97265625,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3112.968505859375,
      "bbox_min": [
        -3179.233642578125,
        -4018.5,
        1080.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3941.97265625,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3112.968505859375,
        -4018.5,
        1080.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3941.97265625,
        1099.616943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3112.968505859375,
        -3947.0,
        1080.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3941.97265625,
        1082.513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5057.22607421875,
      "bbox_min": [
        -3179.233642578125,
        -4018.5,
        1082.513671875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3944.120361328125,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.0,
      "bbox_min": [
        -3160.0,
        -4018.5,
        1082.513671875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3944.120361328125,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3150.0,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3112.968505859375,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3150.0,
        -3985.0,
        1092.0
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3149.70458984375,
        -3960.0,
        1092.0
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3120.891357421875,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3112.968505859375,
        -4018.5,
        1097.5247802734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3119.630615234375,
        -3947.0,
        1082.513671875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3944.120361328125,
        1085.0478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3149.70458984375,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3117.0,
      "bbox_min": [
        -3117.0,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3117.0,
        -4016.0,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3599.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3996.254150390625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -3759.938232421875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3193.511474609375,
        -3996.254150390625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541234850883484,
        -0.7563877701759338,
        0.0
      ],
      "plane_d": -930.5595703125,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3378.606201171875,
        -4152.08349609375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4239.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3425.570068359375,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3440.33251953125,
        -4201.27734375,
        1052.623779296875
      ],
      "bbox_max": [
        -3425.570068359375,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5386.9296875,
      "bbox_min": [
        -3440.33251953125,
        -4200.58203125,
        1094.623779296875
      ],
      "bbox_max": [
        -3425.570068359375,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1121.6236572265625,
      "bbox_min": [
        -3430.738037109375,
        -4189.14013671875,
        1121.623779296875
      ],
      "bbox_max": [
        -3428.32373046875,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3440.33251953125,
        -4200.58203125,
        1094.623779296875
      ],
      "bbox_max": [
        -3425.570068359375,
        -4187.5302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1121.6236572265625,
      "bbox_min": [
        -3440.33251953125,
        -4197.71923828125,
        1121.623779296875
      ],
      "bbox_max": [
        -3438.244384765625,
        -4196.435546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2542707622051239,
        0.23112037777900696,
        0.9391111135482788
      ],
      "plane_d": -932.4862060546875,
      "bbox_min": [
        -3438.83251953125,
        -4200.58203125,
        1094.623779296875
      ],
      "bbox_max": [
        -3425.570068359375,
        -4187.5302734375,
        1097.2947998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2444005310535431,
        0.2444005310535431,
        0.9383692145347595
      ],
      "plane_d": -842.002685546875,
      "bbox_min": [
        -3438.83251953125,
        -4200.58203125,
        1094.623779296875
      ],
      "bbox_max": [
        -3433.9482421875,
        -4196.435546875,
        1096.8094482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3435.49072265625,
        -4210.6396484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3424.660400390625,
        -4192.6982421875,
        1102.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3434.6865234375,
        -4201.578125,
        1096.7835693359375
      ],
      "bbox_max": [
        -3424.66064453125,
        -4192.6982421875,
        1102.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5386.9296875,
      "bbox_min": [
        -3434.6865234375,
        -4201.578125,
        1096.7835693359375
      ],
      "bbox_max": [
        -3424.66064453125,
        -4192.6982421875,
        1102.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2444005310535431,
        0.2444005310535431,
        0.9383692145347595
      ],
      "plane_d": -842.002685546875,
      "bbox_min": [
        -3434.6865234375,
        -4201.578125,
        1096.7835693359375
      ],
      "bbox_max": [
        -3432.78125,
        -4199.943359375,
        1097.331787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3196.19921875,
        -3998.94189453125,
        1082.7816162109375
      ],
      "bbox_max": [
        -3193.511474609375,
        -3996.254150390625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3502.938720703125,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3479.999755859375,
        -4189.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1121.6236572265625,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3998.226806640625,
        1152.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.01700633391737938,
        -0.9998554587364197,
        0.0
      ],
      "plane_d": -4195.24462890625,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3998.226806640625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -3998.226806640625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3438.244384765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -3998.226806640625,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4060.0,
      "bbox_min": [
        -3147.163818359375,
        -4060.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -4004.833740234375,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3147.163818359375,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3109.968505859375,
        -4004.833740234375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071101069450378,
        -0.7071035504341125,
        0.0
      ],
      "plane_d": -5057.2236328125,
      "bbox_min": [
        -3147.163818359375,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3109.968505859375,
        -4004.833740234375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3139.685546875,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3109.968505859375,
        -4012.31201171875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.0,
      "bbox_min": [
        -3139.685546875,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3120.891357421875,
        -4012.31201171875,
        1092.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3438.244384765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4041.88818359375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.9443359375,
      "bbox_min": [
        -3291.98681640625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4041.88818359375,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": -3242.712158203125,
      "bbox_min": [
        -3210.25927734375,
        -4249.7685546875,
        1084.9443359375
      ],
      "bbox_max": [
        -3179.740234375,
        -4179.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3179.740234375,
        -4249.7685546875,
        1063.970458984375
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3167.36328125,
        -4249.72412109375,
        1063.970458984375
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3233.35498046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.521240234375,
        -4041.88818359375,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3233.35498046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3216.391357421875,
        -4071.71044921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666666865348816,
        -0.6666666865348816,
        0.3333333432674408
      ],
      "plane_d": -933.2139892578125,
      "bbox_min": [
        -3222.63623046875,
        -4090.471923828125,
        1063.9705810546875
      ],
      "bbox_max": [
        -3216.391357421875,
        -4071.71044921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3219.063232421875,
        -4082.572265625,
        1072.623779296875
      ],
      "bbox_max": [
        -3216.391357421875,
        -4071.71044921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.59621661901474,
        -0.5943341851234436,
        0.5397154092788696
      ],
      "plane_d": -1081.202392578125,
      "bbox_min": [
        -3233.35498046875,
        -4097.3037109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.63623046875,
        -4082.515380859375,
        1067.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5178.8330078125,
      "bbox_min": [
        -3233.35498046875,
        -4096.5849609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3227.390625,
        -4090.620361328125,
        1059.5777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666666865348816,
        -0.6666666865348816,
        0.3333333432674408
      ],
      "plane_d": -933.2139892578125,
      "bbox_min": [
        -3227.338134765625,
        -4097.3037109375,
        1058.3785400390625
      ],
      "bbox_max": [
        -3222.63623046875,
        -4088.645263671875,
        1067.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5938324332237244,
        -0.5938324332237244,
        0.5428869724273682
      ],
      "plane_d": -1090.173828125,
      "bbox_min": [
        -3230.8251953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5178.8330078125,
      "bbox_min": [
        -3230.8251953125,
        -4098.7421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3225.233154296875,
        -4093.150146484375,
        1057.367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3227.401611328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3227.401611328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4079.870849609375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666666865348816,
        -0.6666666865348816,
        0.3333333432674408
      ],
      "plane_d": -933.2139892578125,
      "bbox_min": [
        -3222.63623046875,
        -4096.1455078125,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4086.0087890625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.59621661901474,
        -0.5943341851234436,
        0.5397154092788696
      ],
      "plane_d": -1081.202392578125,
      "bbox_min": [
        -3227.401611328125,
        -4098.7421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.63623046875,
        -4085.8330078125,
        1063.9705810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5178.8330078125,
      "bbox_min": [
        -3227.401611328125,
        -4098.7421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3225.233154296875,
        -4096.57421875,
        1057.382568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666666865348816,
        -0.6666666865348816,
        0.3333333432674408
      ],
      "plane_d": -933.2139892578125,
      "bbox_min": [
        -3226.671875,
        -4098.7421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.63623046875,
        -4090.471923828125,
        1063.9705810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.59621661901474,
        -0.5943341851234436,
        0.5397154092788696
      ],
      "plane_d": -1081.202392578125,
      "bbox_min": [
        -3219.999755859375,
        -4091.02783203125,
        1055.3375244140625
      ],
      "bbox_max": [
        -3182.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3216.391357421875,
        -4079.900390625,
        1072.623779296875
      ],
      "bbox_max": [
        -3182.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5952767729759216,
        -0.5952798128128052,
        0.5397107005119324
      ],
      "plane_d": -1088.1044921875,
      "bbox_min": [
        -3291.98681640625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.063232421875,
        -4074.390625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5928899049758911,
        -0.5947738885879517,
        0.5428864359855652
      ],
      "plane_d": -1097.1802978515625,
      "bbox_min": [
        -3291.98681640625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.063232421875,
        -4074.390625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.59621661901474,
        -0.5943341851234436,
        0.5397154092788696
      ],
      "plane_d": -1081.202392578125,
      "bbox_min": [
        -3234.2998046875,
        -4095.589599609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.063232421875,
        -4074.390625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5178.8330078125,
      "bbox_min": [
        -3234.2998046875,
        -4095.589599609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3228.3857421875,
        -4089.675537109375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3234.2998046875,
        -4089.675537109375,
        1072.623779296875
      ],
      "bbox_max": [
        -3219.063232421875,
        -4074.390625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666650176048279,
        -0.6666684150695801,
        0.3333333730697632
      ],
      "plane_d": -933.2264404296875,
      "bbox_min": [
        -3287.8447265625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.063232421875,
        -4074.43896484375,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3234.2998046875,
        -4093.7421875,
        1072.623779296875
      ],
      "bbox_max": [
        -3219.063232421875,
        -4074.43896484375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3438.244384765625,
        -4248.2685546875,
        1097.302490234375
      ],
      "bbox_max": [
        -3378.499755859375,
        -4189.14013671875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5386.9296875,
      "bbox_min": [
        -3433.690185546875,
        -4248.2685546875,
        1097.302490234375
      ],
      "bbox_max": [
        -3378.499755859375,
        -4189.14013671875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2444005310535431,
        0.2444005310535431,
        0.9383692145347595
      ],
      "plane_d": -842.002685546875,
      "bbox_min": [
        -3433.690185546875,
        -4248.2685546875,
        1097.302490234375
      ],
      "bbox_max": [
        -3378.499755859375,
        -4193.60791015625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2542707622051239,
        0.23112037777900696,
        0.9391111135482788
      ],
      "plane_d": -932.4862060546875,
      "bbox_min": [
        -3432.78125,
        -4239.7685546875,
        1097.331787109375
      ],
      "bbox_max": [
        -3378.499755859375,
        -4193.60791015625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826853334903717,
        0.9238787889480591,
        0.0
      ],
      "plane_d": 2758.4794921875,
      "bbox_min": [
        -3169.97509765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826853334903717,
        0.9238787889480591,
        0.0
      ],
      "plane_d": 2758.4794921875,
      "bbox_min": [
        -3051.571044921875,
        -4249.7685546875,
        1121.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4206.7998046875,
      "bbox_min": [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4119.7685546875,
      "bbox_min": [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.623779296875,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3646.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3610.999755859375,
      "bbox_min": [
        -3646.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4149.7685546875,
      "bbox_min": [
        -3646.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5527057647705078,
        0.8333765864372253
      ],
      "plane_d": -3223.18896484375,
      "bbox_min": [
        -3646.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4200.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8333765864372253,
        -0.5527057647705078,
        -0.0
      ],
      "plane_d": -5361.11328125,
      "bbox_min": [
        -3646.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4200.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8333765864372253,
        -0.552705705165863,
        0.0
      ],
      "plane_d": 687.533935546875,
      "bbox_min": [
        -3614.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4200.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3653.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3689.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4149.7685546875,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4149.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5527057647705078,
        0.8333765864372253
      ],
      "plane_d": -3223.18896484375,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4200.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8333765864372253,
        -0.552705705165863,
        0.0
      ],
      "plane_d": 723.369140625,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4200.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8333765864372253,
        -0.5527057647705078,
        -0.0
      ],
      "plane_d": -5396.9482421875,
      "bbox_min": [
        -3689.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3685.999755859375,
        -4200.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4178.7685546875,
      "bbox_min": [
        -3653.999755859375,
        -4191.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4161.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4166.7685546875,
      "bbox_min": [
        -3653.999755859375,
        -4178.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4161.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4161.2685546875,
      "bbox_min": [
        -3653.999755859375,
        -4166.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4161.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4166.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4161.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4166.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4161.2685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4173.2685546875,
      "bbox_min": [
        -3653.999755859375,
        -4178.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4173.2685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4178.7685546875,
        1058.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4173.2685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4191.2685546875,
      "bbox_min": [
        -3653.999755859375,
        -4191.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4185.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4185.7685546875,
      "bbox_min": [
        -3653.999755859375,
        -4191.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4185.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4191.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4185.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4191.2685546875,
        1069.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4185.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4206.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4206.7998046875,
        1059.7738037109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1054.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4206.7998046875,
        1059.7738037109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4206.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4206.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4206.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4249.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3675.999755859375,
        -4206.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3749.999755859375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4264.18798828125,
      "bbox_min": [
        -3749.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        3.487878927899146e-07,
        0.0
      ],
      "plane_d": -2919.998291015625,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2214.77978515625,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48899564146995544,
        0.8722862601280212,
        0.0
      ],
      "plane_d": 2783.7412109375,
      "bbox_min": [
        -2214.77978515625,
        -4432.9013671875,
        1167.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4379.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1102.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4919.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1195.5255126953125
      ],
      "bbox_max": [
        -2908.47216796875,
        -4942.994140625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4909.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4719.2421875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4629.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4629.76806640625,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4629.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4821.984375,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2920.0,
        -4835.04296875,
        1082.623779296875
      ],
      "bbox_max": [
        -2916.584716796875,
        -4821.984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4909.7685546875,
        1227.393310546875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4639.62060546875,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4719.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4718.13916015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2920.0,
        -4857.9619140625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4307.7685546875,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2269.60546875,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135422706604004,
        -0.4067438244819641,
        -0.0
      ],
      "plane_d": -3873.526123046875,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7610056400299072,
        -0.6487452983856201,
        -0.0
      ],
      "plane_d": -4560.17578125,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.841796875,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135460257530212,
        -0.4067356288433075,
        -0.0
      ],
      "plane_d": -3861.5,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8099361658096313,
        -0.3606100380420685,
        -0.4625622630119324
      ],
      "plane_d": -2866.8154296875,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1203.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4372.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.499755859375,
        -4319.7685546875,
        1128.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.499755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.499755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1087.623779296875,
      "bbox_min": [
        -2869.999755859375,
        -4361.83251953125,
        1087.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4332.83251953125,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1097.002197265625,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2659.01904296875,
        -4319.7685546875,
        1118.6044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2723.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4322.7685546875,
      "bbox_min": [
        -2723.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2699.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2723.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2723.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9475358724594116,
        0.31964942812919617
      ],
      "plane_d": -4479.82568359375,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9537331461906433,
        0.0,
        0.3006546199321747
      ],
      "plane_d": -3101.376708984375,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4361.732421875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4369.732421875,
      "bbox_min": [
        -2917.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4364.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2917.16259765625,
      "bbox_min": [
        -2917.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4364.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4319.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1048.475830078125,
      "bbox_min": [
        -2889.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4367.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9568694233894348,
        -0.29051825404167175
      ],
      "plane_d": -3872.5517578125,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9620301723480225,
        0.0,
        -0.2729431688785553
      ],
      "plane_d": -2516.362548828125,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4361.732421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2687.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4559.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2687.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2703.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2884.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4372.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4372.7685546875,
        1074.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1065.123779296875,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2855.362548828125,
      "bbox_min": [
        -2869.999755859375,
        -4439.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2855.362548828125,
        -4399.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4417.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4417.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2868.362548828125,
        -4417.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2889.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4372.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2889.999755859375,
        -4449.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2889.999755859375,
        -4444.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4575.96142578125,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4575.96142578125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4014.522705078125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": -3100.363525390625,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -2847.9599609375,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4444.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600293636322021,
        0.2798992693424225,
        -0.0
      ],
      "plane_d": 4907.18798828125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.789697527885437,
        -0.6134963631629944,
        0.0
      ],
      "plane_d": 308.167724609375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14052800834178925,
        0.9900767803192139,
        -0.0
      ],
      "plane_d": 5148.95849609375,
      "bbox_min": [
        -3750.459716796875,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4289.7998046875,
      "bbox_min": [
        -3722.8740234375,
        -4289.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700089693069458,
        -0.0,
        0.24306941032409668
      ],
      "plane_d": 3403.469482421875,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932385265827179,
        0.26299288868904114,
        0.24797670543193817
      ],
      "plane_d": 4451.162109375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.931310772895813,
        0.2715262770652771,
        0.24276229739189148
      ],
      "plane_d": 4492.71728515625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732754826545715,
        0.0,
        0.22964049875736237
      ],
      "plane_d": 3347.911865234375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7658141851425171,
        -0.594942033290863,
        0.2440749555826187
      ],
      "plane_d": 29.72479248046875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3729.92431640625,
        -4260.35546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1222.32177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3733.5146484375,
        -4260.80517578125,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1236.6832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1356099247932434,
        0.955426812171936,
        0.26223912835121155
      ],
      "plane_d": 4679.6083984375,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1350298374891281,
        0.9555009007453918,
        0.2622690796852112
      ],
      "plane_d": 4677.7451171875,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3747.18896484375,
        -4668.23779296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3746.760498046875,
        -4289.7998046875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783878922462463,
        0.06522687524557114,
        0.1962204873561859
      ],
      "plane_d": 3718.708251953125,
      "bbox_min": [
        -3747.18896484375,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4723.5966796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3736.77734375,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4829.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3599.999755859375,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4719.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701423645019531,
        0.0,
        0.24253588914871216
      ],
      "plane_d": -3759.938232421875,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3580.22705078125,
        -4719.7685546875,
        1181.71435546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 13.907958984375,
      "bbox_min": [
        -3244.087890625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3170.900634765625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4484086036682129,
        0.8938286900520325,
        0.0
      ],
      "plane_d": 5564.03759765625,
      "bbox_min": [
        -3079.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9838698506355286,
        0.0,
        0.17888544499874115
      ],
      "plane_d": -3236.50634765625,
      "bbox_min": [
        -3079.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2958.458740234375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": 4645.59619140625,
      "bbox_min": [
        -3079.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2958.458740234375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 4885.83447265625,
      "bbox_min": [
        -3079.999755859375,
        -4710.5654296875,
        1152.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7291637659072876,
        0.6843392848968506,
        0.0
      ],
      "plane_d": 1080.096435546875,
      "bbox_min": [
        -2968.409423828125,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2958.458740234375,
        -4737.49853515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "bbox_max": [
        -2958.458740234375,
        -4737.49853515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2964.98583984375,
        -4740.7734375,
        1082.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 2257.107666015625,
      "bbox_min": [
        -3170.900634765625,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -5585.61865234375,
      "bbox_min": [
        -3170.900634765625,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        -4.187267222732771e-06,
        -0.48562484979629517
      ],
      "plane_d": -2189.474365234375,
      "bbox_min": [
        -3116.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4909895062446594,
        -0.87116539478302
      ],
      "plane_d": 3257.42919921875,
      "bbox_min": [
        -3116.6005859375,
        -4695.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3244.087890625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3170.900634765625,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3244.087890625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3231.590087890625,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138801693916321,
        0.4059842526912689,
        0.0
      ],
      "plane_d": -1039.8768310546875,
      "bbox_min": [
        -3244.087890625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3231.940185546875,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3243.922119140625,
        -4740.7734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3231.940185546875,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.01888239197432995,
        -0.9998217225074768
      ],
      "plane_d": 1142.5185546875,
      "bbox_min": [
        -3675.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.01888239197432995,
        0.9998217225074768
      ],
      "plane_d": -1147.5177001953125,
      "bbox_min": [
        -3632.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1054.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3675.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3600.0,
      "bbox_min": [
        -3699.999755859375,
        -5045.98291015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.291015625,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3600.0,
        -5045.98291015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.541015625,
        1227.393310546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701423645019531,
        0.0,
        0.24253588914871216
      ],
      "plane_d": -3759.938232421875,
      "bbox_min": [
        -3600.0,
        -4854.802734375,
        1090.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.54150390625,
        1202.759765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4850.7685546875,
        1090.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4790.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        0.0,
        -0.936329185962677
      ],
      "plane_d": -222.0233154296875,
      "bbox_min": [
        -3599.999755859375,
        -4800.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3565.65576171875,
        -4790.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.0,
        0.936329185962677
      ],
      "plane_d": 231.62548828125,
      "bbox_min": [
        -3599.999755859375,
        -4800.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3565.65576171875,
        -4790.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4800.0,
      "bbox_min": [
        -3599.999755859375,
        -4800.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3565.65576171875,
        -4790.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4790.0,
      "bbox_min": [
        -3599.999755859375,
        -4800.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3565.65576171875,
        -4790.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701439738273621,
        0.0,
        0.24252967536449432
      ],
      "plane_d": -3725.98193359375,
      "bbox_min": [
        -3567.999755859375,
        -4800.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3565.65576171875,
        -4790.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4854.802734375,
        1102.623779296875
      ],
      "bbox_max": [
        -3574.9658203125,
        -4829.7685546875,
        1202.759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3347.175537109375,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3332.493896484375,
        -4850.7685546875,
        1102.6241455078125
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741573691368103,
        1.5244095266098157e-06,
        -0.4856429696083069
      ],
      "plane_d": -2189.39599609375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3119.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.6494140625,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -3119.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4759.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2929.999755859375,
        -4932.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 2056.304443359375,
      "bbox_min": [
        -3119.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4759.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3031.306884765625,
        -5028.2685546875,
        1140.0
      ],
      "bbox_max": [
        -2970.626953125,
        -4978.57177734375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 235.0537109375,
      "bbox_min": [
        -3119.999755859375,
        -4976.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4759.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": -1976.3916015625,
      "bbox_min": [
        -3119.999755859375,
        -4976.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4759.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3119.999755859375,
        -4976.0,
        1092.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4759.7685546875,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.32747265696525574,
        -0.0,
        -0.9448606371879578
      ],
      "plane_d": 40.83355712890625,
      "bbox_min": [
        -3099.999755859375,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4965.7685546875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3085.73388671875,
      "bbox_min": [
        -3085.73388671875,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4965.7685546875,
        1106.5679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4735.888671875,
      "bbox_min": [
        -3119.999755859375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4759.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3079.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4759.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3077.07080078125,
        -4932.697265625,
        1092.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3069.999755859375,
        -4932.697265625,
        1092.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 5268.81396484375,
      "bbox_min": [
        -3077.999755859375,
        -4764.3359375,
        1092.623779296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264952301979065,
        -0.0,
        -0.5629439353942871
      ],
      "plane_d": -1927.408447265625,
      "bbox_min": [
        -3119.999755859375,
        -4965.7685546875,
        1101.606689453125
      ],
      "bbox_max": [
        -3079.999755859375,
        -4934.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4939.76806640625,
      "bbox_min": [
        -3096.669677734375,
        -4939.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4934.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3093.06982421875,
        -4934.7685546875,
        1103.6322021484375
      ],
      "bbox_max": [
        -3083.73388671875,
        -4934.7685546875,
        1117.338623046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4939.76806640625,
      "bbox_min": [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.365966796875,
        -4934.7685546875,
        1106.5679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3085.73388671875,
        -4934.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3083.73388671875,
        -4934.7685546875,
        1106.5679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32747265696525574,
        -0.0,
        -0.9448606371879578
      ],
      "plane_d": 40.83355712890625,
      "bbox_min": [
        -3119.999755859375,
        -4965.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3091.182861328125,
        -4934.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3103.053466796875,
        -4939.7685546875,
        1114.5679931640625
      ],
      "bbox_max": [
        -3091.182861328125,
        -4934.7685546875,
        1119.740478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.7685546875,
      "bbox_min": [
        -3116.265625,
        -4939.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3099.999755859375,
        -4934.7685546875,
        1118.68212890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.32747307419776917,
        0.0,
        0.944860577583313
      ],
      "plane_d": -2073.1650390625,
      "bbox_min": [
        -3110.096923828125,
        -4939.7685546875,
        1116.240966796875
      ],
      "bbox_max": [
        -3103.053466796875,
        -4934.7685546875,
        1118.68212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3111.6005859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.7734375,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 2056.304443359375,
      "bbox_min": [
        -3106.045166015625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": -1976.3916015625,
      "bbox_min": [
        -3106.045166015625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3106.045166015625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3106.044921875,
        -4946.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3093.966064453125,
        -4946.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1052.86376953125
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1054.6905517578125
      ],
      "bbox_max": [
        -3069.999755859375,
        -4929.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4735.888671875,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1056.5172119140625
      ],
      "bbox_max": [
        -3077.07080078125,
        -4932.697265625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3079.999755859375,
        -4939.7685546875,
        1056.5172119140625
      ],
      "bbox_max": [
        -3077.07080078125,
        -4932.697265625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3093.966064453125,
        -4946.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1060.8817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4735.888671875,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1057.2738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3079.999755859375,
        -4939.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1057.2738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3077.07080078125,
        -4932.697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1056.5172119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3069.999755859375,
        -4932.697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1054.6905517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1962762176990509,
        0.09117656201124191,
        -0.9763003587722778
      ],
      "plane_d": 2086.580810546875,
      "bbox_min": [
        -3106.044921875,
        -4879.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17616155743598938,
        0.03705311194062233,
        -0.9836636185646057
      ],
      "plane_d": 1771.610107421875,
      "bbox_min": [
        -3106.044921875,
        -4879.7685546875,
        1062.983154296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3106.044921875,
        -4879.7685546875,
        1063.6112060546875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14628201723098755,
        0.1660124659538269,
        -0.9752135276794434
      ],
      "plane_d": 2295.2158203125,
      "bbox_min": [
        -3106.044921875,
        -4879.7685546875,
        1063.6112060546875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3106.044921875,
        -4879.7685546875,
        1063.6112060546875
      ],
      "bbox_max": [
        -3026.156494140625,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37803196907043457,
        0.0,
        0.9257925748825073
      ],
      "plane_d": -2160.775390625,
      "bbox_min": [
        -3098.36865234375,
        -4879.7685546875,
        1063.6112060546875
      ],
      "bbox_max": [
        -3026.156494140625,
        -4798.87841796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3097.450439453125,
        -4875.201171875,
        1063.6112060546875
      ],
      "bbox_max": [
        -3026.156494140625,
        -4798.87841796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2286498099565506,
        0.11457086354494095,
        0.9667434096336365
      ],
      "plane_d": -1184.240966796875,
      "bbox_min": [
        -3097.450439453125,
        -4875.201171875,
        1064.5283203125
      ],
      "bbox_max": [
        -3027.5712890625,
        -4798.87841796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3097.450439453125,
        -4859.7685546875,
        1064.5283203125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3097.450439453125,
        -4859.7685546875,
        1064.5283203125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3097.450439453125,
        -4859.7685546875,
        1064.5283203125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3097.450439453125,
        -4859.7685546875,
        1064.5283203125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1077.646728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3038.148193359375,
        -4819.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1077.646728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24678324162960052,
        0.02719999849796295,
        0.9686889052391052
      ],
      "plane_d": -1666.2080078125,
      "bbox_min": [
        -3087.82666015625,
        -4861.71044921875,
        1070.6024169921875
      ],
      "bbox_max": [
        -3027.5712890625,
        -4798.87841796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3027.5712890625,
        -4798.87841796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0005590711371041834,
        0.3637598156929016,
        -0.9314926862716675
      ],
      "plane_d": 2755.78857421875,
      "bbox_min": [
        -3030.836181640625,
        -4800.23291015625,
        1082.09375
      ],
      "bbox_max": [
        -3027.5712890625,
        -4798.87841796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3040.399658203125,
        -4819.7685546875,
        1077.523193359375
      ],
      "bbox_max": [
        -3037.999755859375,
        -4807.7041015625,
        1081.4393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476786494255066,
        0.016561293974518776,
        0.9668603539466858
      ],
      "plane_d": -1740.162353515625,
      "bbox_min": [
        -3049.715576171875,
        -4848.052734375,
        1079.248779296875
      ],
      "bbox_max": [
        -3036.1943359375,
        -4835.07568359375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3087.82666015625,
        -4859.7685546875,
        1070.6024169921875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4812.62744140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3039.420166015625,
        -4819.7685546875,
        1080.876953125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4812.62744140625,
        1082.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3106.044921875,
        -4821.88623046875,
        1076.518798828125
      ],
      "bbox_max": [
        -3028.7900390625,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0005590711371041834,
        0.3637598156929016,
        -0.9314926862716675
      ],
      "plane_d": 2755.78857421875,
      "bbox_min": [
        -3044.791259765625,
        -4821.88623046875,
        1079.7874755859375
      ],
      "bbox_max": [
        -3028.7900390625,
        -4798.85400390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3041.044677734375,
        -4807.7041015625,
        1079.7874755859375
      ],
      "bbox_max": [
        -3030.836181640625,
        -4800.23291015625,
        1082.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3038.4208984375,
        -4821.88623046875,
        1082.45703125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3102.653076171875,
        -4768.0029296875,
        1076.155029296875
      ],
      "bbox_max": [
        -3090.634033203125,
        -4766.8359375,
        1078.489501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3102.450927734375,
        -4769.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3090.7392578125,
        -4767.04638671875,
        1078.0682373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3095.482177734375,
        -4859.7685546875,
        1062.983154296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4848.052734375,
        1072.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3095.482177734375,
        -4859.7685546875,
        1062.983154296875
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3070.636962890625,
        -4858.3037109375,
        1068.1158447265625
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7291637659072876,
        0.6843392848968506,
        0.0
      ],
      "plane_d": 1080.096435546875,
      "bbox_min": [
        -2977.03515625,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 2056.304443359375,
      "bbox_min": [
        -3111.6005859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3111.6005859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": -1976.3916015625,
      "bbox_min": [
        -3111.6005859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -2979.999755859375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.051469940692186356,
        0.1215628907084465,
        -0.9912483096122742
      ],
      "plane_d": 1501.496826171875,
      "bbox_min": [
        -3111.6005859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3021.355224609375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06524179130792618,
        0.13515298068523407,
        -0.988674521446228
      ],
      "plane_d": 1521.8194580078125,
      "bbox_min": [
        -3111.6005859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2369917780160904,
        0.0981641411781311,
        -0.9665396213531494
      ],
      "plane_d": 796.7720947265625,
      "bbox_min": [
        -3091.98583984375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2550874352455139,
        0.018345560878515244,
        0.9667439460754395
      ],
      "plane_d": -1732.361083984375,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4762.04052734375,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476786494255066,
        0.016561293974518776,
        0.9668603539466858
      ],
      "plane_d": -1740.162353515625,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4762.04052734375,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4762.04052734375,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        -0.38267579674720764,
        0.0
      ],
      "plane_d": -4735.888671875,
      "bbox_min": [
        -3079.999755859375,
        -4946.83984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3079.999755859375,
        -4939.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3069.999755859375,
        -4932.697265625,
        1082.623779296875
      ],
      "bbox_max": [
        -3062.9287109375,
        -4929.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 5268.81396484375,
      "bbox_min": [
        -3066.577880859375,
        -4864.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4762.04052734375,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3039.73974609375,
        -4864.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4819.7685546875,
        1084.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2286498099565506,
        0.11457086354494095,
        0.9667434096336365
      ],
      "plane_d": -1184.240966796875,
      "bbox_min": [
        -3039.5458984375,
        -4864.84912109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4859.9853515625,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24678324162960052,
        0.02719999849796295,
        0.9686889052391052
      ],
      "plane_d": -1666.2080078125,
      "bbox_min": [
        -3037.97314453125,
        -4862.19482421875,
        1082.623779296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4859.9853515625,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12214395403862,
        0.05059313401579857,
        -0.991222083568573
      ],
      "plane_d": 947.8853759765625,
      "bbox_min": [
        -3091.98583984375,
        -4782.8134765625,
        1089.561279296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19617927074432373,
        -0.0,
        -0.980567991733551
      ],
      "plane_d": 467.55218505859375,
      "bbox_min": [
        -3077.999755859375,
        -4782.8134765625,
        1089.561279296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 5268.81396484375,
      "bbox_min": [
        -3077.999755859375,
        -4764.3359375,
        1089.561279296875
      ],
      "bbox_max": [
        -3055.038818359375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3091.98583984375,
        -4759.9384765625,
        1092.28369140625
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3111.6005859375,
        -4760.44873046875,
        1091.2637939453125
      ],
      "bbox_max": [
        -3087.185302734375,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0005590711371041834,
        0.3637598156929016,
        -0.9314926862716675
      ],
      "plane_d": 2755.78857421875,
      "bbox_min": [
        -3111.587158203125,
        -4810.72802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3021.355224609375,
        -4759.78076171875,
        1092.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3041.044677734375,
        -4810.72802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3021.355224609375,
        -4796.8076171875,
        1083.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3027.5712890625,
        -4799.884765625,
        1082.623779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4796.8076171875,
        1083.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3111.587158203125,
        -4764.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3087.4404296875,
        -4759.78076171875,
        1092.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9056028723716736,
        0.4241252839565277,
        0.001009006635285914
      ],
      "plane_d": -905.1506958007812,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3089.37841796875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3308.169189453125,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3089.37841796875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3223.03857421875,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3089.37841796875,
        -4740.77392578125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37803196907043457,
        0.0,
        0.9257925748825073
      ],
      "plane_d": -2160.775390625,
      "bbox_min": [
        -3223.03857421875,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3093.6240234375,
        -4740.77392578125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3137.999755859375,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3093.6240234375,
        -4859.7685546875,
        1068.8065185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3137.999755859375,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3093.6240234375,
        -4859.7685546875,
        1067.1539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3109.7431640625,
        -4899.7685546875,
        1060.266357421875
      ],
      "bbox_max": [
        -3093.6240234375,
        -4879.7685546875,
        1067.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3109.7431640625,
        -4879.7685546875,
        1060.266357421875
      ],
      "bbox_max": [
        -3093.6240234375,
        -4879.7685546875,
        1067.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3108.5498046875,
        -4899.7685546875,
        1060.8817138671875
      ],
      "bbox_max": [
        -3093.966064453125,
        -4890.423828125,
        1064.649169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.62841796875,
      "bbox_min": [
        -3223.03857421875,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3100.4892578125,
        -4740.77392578125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1962762027978897,
        0.09117655456066132,
        -0.9763004183769226
      ],
      "plane_d": 871.4920043945312,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3100.4892578125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17616158723831177,
        0.03705311939120293,
        -0.9836636781692505
      ],
      "plane_d": 680.149658203125,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3100.4892578125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1758042424917221,
        0.038869597017765045,
        -0.9836574792861938
      ],
      "plane_d": 690.1115112304688,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.307861328125
      ],
      "bbox_max": [
        -3100.4892578125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14644506573677063,
        0.15934692323207855,
        -0.9763004183769226
      ],
      "plane_d": 1359.9833984375,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.307861328125
      ],
      "bbox_max": [
        -3100.4892578125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        -0.5555711388587952,
        -0.0
      ],
      "plane_d": -5343.529296875,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.307861328125
      ],
      "bbox_max": [
        -3102.477783203125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        -0.19508720934391022,
        -0.0
      ],
      "plane_d": -4065.03759765625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.307861328125
      ],
      "bbox_max": [
        -3102.477783203125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.307861328125
      ],
      "bbox_max": [
        -3102.477783203125,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.307861328125
      ],
      "bbox_max": [
        -3102.477783203125,
        -4822.8994140625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3150.283935546875,
        -4879.7685546875,
        1064.8292236328125
      ],
      "bbox_max": [
        -3102.477783203125,
        -4868.052734375,
        1079.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509625434875488,
        0.9807841777801514,
        -0.0
      ],
      "plane_d": 5395.08984375,
      "bbox_min": [
        -3150.283935546875,
        -4879.7685546875,
        1067.123779296875
      ],
      "bbox_max": [
        -3121.999755859375,
        -4868.052734375,
        1079.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3150.283935546875,
        -4876.7236328125,
        1070.6708984375
      ],
      "bbox_max": [
        -3137.30712890625,
        -4868.052734375,
        1079.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3150.283935546875,
        -4899.7685546875,
        1064.649169921875
      ],
      "bbox_max": [
        -3108.5498046875,
        -4868.052734375,
        1073.3734130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509625434875488,
        0.9807841777801514,
        -0.0
      ],
      "plane_d": 5395.08984375,
      "bbox_min": [
        -3137.30712890625,
        -4879.7685546875,
        1067.123779296875
      ],
      "bbox_max": [
        -3121.999755859375,
        -4876.7236328125,
        1070.6708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3113.549072265625,
        -4879.7685546875,
        1064.4296875
      ],
      "bbox_max": [
        -3105.112060546875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3109.1005859375,
        -4765.60791015625,
        1080.9447021484375
      ],
      "bbox_max": [
        -3105.112060546875,
        -4764.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14628201723098755,
        0.16601243615150452,
        -0.9752134680747986
      ],
      "plane_d": 1391.5875244140625,
      "bbox_min": [
        -3181.999755859375,
        -4855.07568359375,
        1072.623779296875
      ],
      "bbox_max": [
        -3100.4892578125,
        -4765.30419921875,
        1081.5523681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3108.832763671875,
        -4769.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3100.4892578125,
        -4765.30419921875,
        1081.5523681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3115.899658203125,
        -4879.7685546875,
        1064.161865234375
      ],
      "bbox_max": [
        -3109.08740234375,
        -4879.7685546875,
        1065.649658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509625434875488,
        0.9807841777801514,
        -0.0
      ],
      "plane_d": 5395.08984375,
      "bbox_min": [
        -3137.30712890625,
        -4878.3037109375,
        1068.115966796875
      ],
      "bbox_max": [
        -3129.36328125,
        -4876.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3223.03857421875,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.96435546875,
        -4750.25830078125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3308.169189453125,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3308.169189453125,
        -4932.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9060541987419128,
        0.4231615662574768,
        -3.4665109893694535e-08
      ],
      "plane_d": -910.1381225585938,
      "bbox_min": [
        -3270.07763671875,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9055988192558289,
        0.42413514852523804,
        0.0
      ],
      "plane_d": -903.927734375,
      "bbox_min": [
        -3246.87841796875,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3246.82861328125,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3246.82861328125,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3246.82861328125,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1100.5728759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4992690682411194,
        0.8664470314979553,
        0.0
      ],
      "plane_d": 5781.10546875,
      "bbox_min": [
        -3246.82861328125,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1095.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3181.999755859375,
        -4965.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4838.76220703125,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        -0.19508720934391022,
        -0.0
      ],
      "plane_d": -4065.03759765625,
      "bbox_min": [
        -3181.999755859375,
        -4882.19482421875,
        1082.623779296875
      ],
      "bbox_max": [
        -3164.42626953125,
        -4838.76220703125,
        1089.5079345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        -0.5555711388587952,
        -0.0
      ],
      "plane_d": -5343.529296875,
      "bbox_min": [
        -3181.999755859375,
        -4882.19482421875,
        1082.623779296875
      ],
      "bbox_max": [
        -3164.42626953125,
        -4838.76220703125,
        1089.5079345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        0.19508720934391022,
        0.0
      ],
      "plane_d": -2176.68359375,
      "bbox_min": [
        -3181.999755859375,
        -4839.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3181.799560546875,
        -4838.76220703125,
        1089.5079345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1094.9998779296875,
      "bbox_min": [
        -3246.82861328125,
        -4838.76220703125,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1095.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        0.5555711388587952,
        0.0
      ],
      "plane_d": 34.142333984375,
      "bbox_min": [
        -3166.544677734375,
        -4800.5126953125,
        1095.0
      ],
      "bbox_max": [
        -3164.42626953125,
        -4797.34228515625,
        1095.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999457597732544,
        -0.8660286068916321,
        0.0
      ],
      "plane_d": -5770.419921875,
      "bbox_min": [
        -3242.132080078125,
        -4838.76220703125,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314690589904785,
        0.5555711388587952,
        0.0
      ],
      "plane_d": 34.142333984375,
      "bbox_min": [
        -3179.539794921875,
        -4827.40087890625,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        0.19508720934391022,
        0.0
      ],
      "plane_d": -2176.68359375,
      "bbox_min": [
        -3179.539794921875,
        -4827.40087890625,
        1082.623779296875
      ],
      "bbox_max": [
        -3106.044921875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14644506573677063,
        0.15934692323207855,
        -0.9763004183769226
      ],
      "plane_d": 1359.9833984375,
      "bbox_min": [
        -3178.644287109375,
        -4822.8994140625,
        1082.623779296875
      ],
      "bbox_max": [
        -3172.42822265625,
        -4816.8076171875,
        1083.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3177.4326171875,
        -4819.884765625,
        1082.623779296875
      ],
      "bbox_max": [
        -3172.42822265625,
        -4816.8076171875,
        1083.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        0.19508720934391022,
        0.0
      ],
      "plane_d": -2176.68359375,
      "bbox_min": [
        -3181.799560546875,
        -4838.76220703125,
        1082.623779296875
      ],
      "bbox_max": [
        -3179.53955078125,
        -4827.40087890625,
        1091.0233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9033738970756531,
        0.42883458733558655,
        -0.004077742341905832
      ],
      "plane_d": -869.732666015625,
      "bbox_min": [
        -3246.87841796875,
        -4801.291015625,
        1082.623779296875
      ],
      "bbox_max": [
        -3222.96435546875,
        -4750.33740234375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4992690682411194,
        0.8664470314979553,
        0.0
      ],
      "plane_d": 5781.10546875,
      "bbox_min": [
        -3246.87841796875,
        -4801.291015625,
        1082.623779296875
      ],
      "bbox_max": [
        -3242.132080078125,
        -4791.263671875,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3270.07763671875,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.87841796875,
        -4801.26220703125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9061561822891235,
        0.42292529344558716,
        -0.003878816729411483
      ],
      "plane_d": -907.3564453125,
      "bbox_min": [
        -3270.06005859375,
        -4850.7685546875,
        1095.0
      ],
      "bbox_max": [
        -3246.87841796875,
        -4801.26220703125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1484331637620926,
        0.06927739083766937,
        0.986492931842804
      ],
      "plane_d": -1233.1124267578125,
      "bbox_min": [
        -3270.06005859375,
        -4850.7685546875,
        1098.61474609375
      ],
      "bbox_max": [
        -3252.545654296875,
        -4813.37158203125,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.16366951167583466,
        0.98651522397995
      ],
      "plane_d": -289.88616943359375,
      "bbox_min": [
        -3270.06005859375,
        -4850.7685546875,
        1098.61474609375
      ],
      "bbox_max": [
        -3269.999755859375,
        -4850.7138671875,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3319.999755859375,
        -4932.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3223.016357421875,
        -4740.7734375,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9138801693916321,
        0.4059842526912689,
        0.0
      ],
      "plane_d": -1039.8768310546875,
      "bbox_min": [
        -3319.999755859375,
        -4829.67236328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3223.016357421875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3231.940185546875,
        -4750.28173828125,
        1052.623779296875
      ],
      "bbox_max": [
        -3223.016357421875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10610295832157135,
        0.9943552017211914,
        0.0
      ],
      "plane_d": 5150.78955078125,
      "bbox_min": [
        -3319.999755859375,
        -4829.67236328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4932.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9143241047859192,
        0.4049834907054901,
        0.0
      ],
      "plane_d": -1046.1676025390625,
      "bbox_min": [
        -3319.999755859375,
        -4829.67236328125,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9061561822891235,
        0.42292529344558716,
        -0.003878816729411483
      ],
      "plane_d": -907.3564453125,
      "bbox_min": [
        -3264.823974609375,
        -4813.11376953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9029519557952881,
        0.42863431572914124,
        -0.030828554183244705
      ],
      "plane_d": -840.0320434570312,
      "bbox_min": [
        -3246.87841796875,
        -4801.26220703125,
        1091.3328857421875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9153205752372742,
        0.40272602438926697,
        0.0
      ],
      "plane_d": -1038.0235595703125,
      "bbox_min": [
        -3241.18115234375,
        -4789.10205078125,
        1091.3328857421875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4787.7001953125,
      "bbox_min": [
        -3264.823974609375,
        -4788.87109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.9153205752372742,
        0.40272602438926697,
        0.0
      ],
      "plane_d": -1038.0235595703125,
      "bbox_min": [
        -3241.079345703125,
        -4788.87109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3253.999755859375,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3246.999755859375,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4786.7001953125,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3247.90869140625,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -3247.90869140625,
        -4787.7001953125,
        1094.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3253.0908203125,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3247.90869140625,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1094.623779296875
      ],
      "bbox_max": [
        -3253.0908203125,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1093.623779296875,
      "bbox_min": [
        -3253.0908203125,
        -4787.7001953125,
        1093.623779296875
      ],
      "bbox_max": [
        -3247.90869140625,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -3253.0908203125,
        -4787.7001953125,
        1094.623779296875
      ],
      "bbox_max": [
        -3247.90869140625,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10610295832157135,
        0.9943552017211914,
        -0.0
      ],
      "plane_d": 5150.78955078125,
      "bbox_min": [
        -3319.999755859375,
        -4829.67236328125,
        1082.623779296875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1095.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9061561822891235,
        0.42292529344558716,
        -0.003878816729411483
      ],
      "plane_d": -907.3564453125,
      "bbox_min": [
        -3252.5615234375,
        -4813.40576171875,
        1098.53662109375
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16366951167583466,
        -0.98651522397995
      ],
      "plane_d": 289.88616943359375,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1089.5960693359375
      ],
      "bbox_max": [
        -3270.034423828125,
        -4825.7685546875,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01479284092783928,
        0.13863268494606018,
        0.9902334809303284
      ],
      "plane_d": -366.30670166015625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1094.47607421875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10610295832157135,
        0.9943552017211914,
        -0.0
      ],
      "plane_d": 5150.78955078125,
      "bbox_min": [
        -3319.999755859375,
        -4829.67236328125,
        1094.47607421875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1095.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10610295832157135,
        0.9943552017211914,
        -0.0
      ],
      "plane_d": 5150.78955078125,
      "bbox_min": [
        -3319.999755859375,
        -4829.67236328125,
        1089.5960693359375
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1095.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3319.999755859375,
        -5044.55859375,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4947.42724609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3290.547119140625,
        -4932.2685546875,
        1213.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3295.838623046875,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3295.838623046875,
        -4947.5576171875,
        1152.623779296875
      ],
      "bbox_max": [
        -3275.381591796875,
        -4932.2685546875,
        1213.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2924.617919921875,
        -4942.994140625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1195.5255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5839508175849915,
        0.5839548110961914,
        0.5639132261276245
      ],
      "plane_d": 3992.897705078125,
      "bbox_min": [
        -2987.251708984375,
        -4976.64208984375,
        1152.623779296875
      ],
      "bbox_max": [
        -2979.098876953125,
        -4965.7685546875,
        1166.2159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.497753769159317,
        0.6427804827690125,
        0.5823009610176086
      ],
      "plane_d": 4086.61962890625,
      "bbox_min": [
        -3214.99951171875,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.583952009677887,
        0.5839559435844421,
        0.5639109015464783
      ],
      "plane_d": 372.40728759765625,
      "bbox_min": [
        -3214.99951171875,
        -4980.81591796875,
        1152.623779296875
      ],
      "bbox_max": [
        -3184.010498046875,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49775373935699463,
        0.6427803635597229,
        0.582301139831543
      ],
      "plane_d": 1000.5457153320312,
      "bbox_min": [
        -3054.07763671875,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5839508175849915,
        0.5839548110961914,
        0.5639132261276245
      ],
      "plane_d": 3992.897705078125,
      "bbox_min": [
        -3015.989013671875,
        -4980.81591796875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9749282002449036,
        0.0,
        -0.22251980006694794
      ],
      "plane_d": -2600.0576171875,
      "bbox_min": [
        -2946.8349609375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2946.8349609375,
        -4856.3642578125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -2929.999755859375,
        -4852.89501953125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1179.3675537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3319.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9607518315315247,
        0.0,
        0.27740928530693054
      ],
      "plane_d": -3509.4443359375,
      "bbox_min": [
        -3319.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3319.999755859375,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3292.71533203125,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4762.7685546875,
      "bbox_min": [
        -3699.999755859375,
        -4854.5673828125,
        1052.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4741.05810546875,
        1201.8182373046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4854.5673828125,
        1052.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4762.7685546875,
        1201.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4829.7685546875,
      "bbox_min": [
        -3699.999755859375,
        -4829.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4817.2685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.7685546875,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4817.2685546875,
        1062.623291015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3646.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4817.2685546875,
        1062.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3610.999755859375,
      "bbox_min": [
        -3610.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4817.2685546875,
        1062.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3689.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4817.2685546875,
        1062.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3653.999755859375,
      "bbox_min": [
        -3653.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4817.2685546875,
        1062.623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.623779296875,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3646.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3610.999755859375,
      "bbox_min": [
        -3646.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.7685546875,
      "bbox_min": [
        -3646.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 1745.271484375,
      "bbox_min": [
        -3646.999755859375,
        -4768.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": -389.25048828125,
      "bbox_min": [
        -3646.999755859375,
        -4768.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 5649.77001953125,
      "bbox_min": [
        -3614.999755859375,
        -4768.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3610.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3653.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3689.999755859375,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.7685546875,
      "bbox_min": [
        -3689.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 1745.271484375,
      "bbox_min": [
        -3689.999755859375,
        -4768.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 5685.54833984375,
      "bbox_min": [
        -3689.999755859375,
        -4768.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3653.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": -425.028564453125,
      "bbox_min": [
        -3689.999755859375,
        -4768.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3685.999755859375,
        -4762.7685546875,
        1081.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4796.2685546875,
      "bbox_min": [
        -3653.999755859375,
        -4815.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4774.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4779.7685546875,
      "bbox_min": [
        -3653.999755859375,
        -4796.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4774.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4774.2685546875,
      "bbox_min": [
        -3653.999755859375,
        -4779.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4774.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4779.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4774.2685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1063.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4779.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4774.2685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4790.7685546875,
      "bbox_min": [
        -3653.999755859375,
        -4796.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4790.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4796.2685546875,
        1058.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4790.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4809.7685546875,
      "bbox_min": [
        -3653.999755859375,
        -4815.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4809.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4815.2685546875,
      "bbox_min": [
        -3653.999755859375,
        -4815.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4809.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4815.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4809.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.623779296875,
      "bbox_min": [
        -3653.999755859375,
        -4815.2685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -3646.999755859375,
        -4809.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.01888239197432995,
        -0.9998217225074768
      ],
      "plane_d": 1142.5185546875,
      "bbox_min": [
        -3675.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1054.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4762.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4762.7685546875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3675.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.01888239197432995,
        0.9998217225074768
      ],
      "plane_d": -1147.5177001953125,
      "bbox_min": [
        -3632.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3295.838623046875,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3347.175537109375,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3369.999755859375,
        -5008.603515625,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8356147408485413,
        0.0,
        -0.5493159294128418
      ],
      "plane_d": -1788.7464599609375,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2989.006591796875,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2959.9150390625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3014.40673828125,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3014.40673828125,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701423645019531,
        0.0,
        0.24253588914871216
      ],
      "plane_d": -3759.938232421875,
      "bbox_min": [
        -3600.0,
        -4863.9697265625,
        1201.8182373046875
      ],
      "bbox_max": [
        -3566.1171875,
        -4744.802734375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4863.9697265625,
        1201.8182373046875
      ],
      "bbox_max": [
        -3566.1171875,
        -4854.5673828125,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3302.565185546875,
        -4912.5498046875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9607518315315247,
        0.0,
        0.27740928530693054
      ],
      "plane_d": -3509.4443359375,
      "bbox_min": [
        -3302.565185546875,
        -4912.111328125,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3292.71533203125,
        -4855.56982421875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4879.7685546875,
        1238.15380859375
      ],
      "bbox_max": [
        -3549.999755859375,
        -4863.6513671875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8356146812438965,
        0.0,
        -0.5493159294128418
      ],
      "plane_d": 3392.064453125,
      "bbox_min": [
        -3298.212890625,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3298.212890625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3253.16455078125,
        -4859.85693359375,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3221.869873046875,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3210.992919921875,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4879.7685546875,
        1198.05712890625
      ],
      "bbox_max": [
        -3600.0,
        -4853.626953125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -2.5699014258862007e-06
      ],
      "plane_d": -3128.597412109375,
      "bbox_min": [
        -3170.00048828125,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923880934715271,
        0.38268008828163147,
        0.0
      ],
      "plane_d": -1233.537841796875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268569111824036,
        0.9238786101341248,
        0.0
      ],
      "plane_d": 2758.4775390625,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4525.01611328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3102.499755859375,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -7.511212606914341e-05,
        -0.00015022425213828683
      ],
      "plane_d": -3092.68310546875,
      "bbox_min": [
        -3092.50146484375,
        -4539.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3092.50048828125,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1101.6236572265625,
      "bbox_min": [
        -3128.60009765625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4389.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4409.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4389.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4409.76806640625,
      "bbox_min": [
        -3070.10009765625,
        -4409.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1121.623779296875,
      "bbox_min": [
        -3046.499755859375,
        -4261.66796875,
        1121.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6304340362548828,
        0.0,
        0.7762427926063538
      ],
      "plane_d": -2827.50341796875,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -4.763341712532565e-05
      ],
      "plane_d": -3169.94970703125,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4629.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3155.499755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4419.7685546875,
      "bbox_min": [
        -3151.214111328125,
        -4419.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.682324230670929,
        0.0,
        0.7310497760772705
      ],
      "plane_d": -2922.59423828125,
      "bbox_min": [
        -3151.214111328125,
        -4419.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1066.623779296875,
      "bbox_min": [
        -3140.499755859375,
        -4419.7685546875,
        1066.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4389.7685546875,
      "bbox_min": [
        -3155.499755859375,
        -4389.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -3155.499755859375,
        -4389.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3155.499755859375,
        -4389.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4379.7685546875,
      "bbox_min": [
        -3151.214111328125,
        -4389.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6823182702064514,
        0.0,
        0.7310552597045898
      ],
      "plane_d": -2922.581298828125,
      "bbox_min": [
        -3151.214111328125,
        -4389.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1066.623779296875,
      "bbox_min": [
        -3140.499755859375,
        -4389.7685546875,
        1066.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3412.019775390625,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3169.999755859375,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4309.7685546875,
      "bbox_min": [
        -3169.999755859375,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4309.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4309.7685546875,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": -3242.712158203125,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.9443359375,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": -1945.72900390625,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4309.7685546875,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3207.499755859375,
        -4309.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6564568281173706,
        0.37900400161743164,
        0.6522426605224609
      ],
      "plane_d": -1243.078857421875,
      "bbox_min": [
        -3412.019775390625,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3239.980224609375,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3056.454833984375,
      "bbox_min": [
        -3309.619873046875,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3239.980224609375,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4444.03955078125,
      "bbox_min": [
        -3309.619873046875,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3239.980224609375,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6466192007064819,
        0.6927235722541809,
        -0.3194020688533783
      ],
      "plane_d": 1189.50048828125,
      "bbox_min": [
        -3307.855712890625,
        -4288.404296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3239.980224609375,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2632.378662109375,
      "bbox_min": [
        -3279.90576171875,
        -4288.404296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3239.980224609375,
        -4260.1806640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2424.00732421875,
      "bbox_min": [
        -3279.90576171875,
        -4283.4892578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3241.74462890625,
        -4260.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3279.90576171875,
        -4283.4892578125,
        1077.5
      ],
      "bbox_max": [
        -3265.823486328125,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1248.33935546875,
      "bbox_min": [
        -3274.800048828125,
        -4288.404296875,
        1077.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3274.800048828125,
        -4285.408203125,
        1077.5
      ],
      "bbox_max": [
        -3265.823486328125,
        -4280.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5424.59765625,
      "bbox_min": [
        -3307.855712890625,
        -4281.93115234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3267.425048828125,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1275.581298828125,
      "bbox_min": [
        -3307.855712890625,
        -4281.93115234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3274.800048828125,
        -4260.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3283.776611328125,
        -4281.93115234375,
        1077.5
      ],
      "bbox_max": [
        -3274.800048828125,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3783.358154296875,
      "bbox_min": [
        -3282.175048828125,
        -4277.16552734375,
        1077.5
      ],
      "bbox_max": [
        -3267.425048828125,
        -4267.97607421875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3279.288330078125,
        -4277.16552734375,
        1077.5
      ],
      "bbox_max": [
        -3270.311767578125,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4279.5302734375,
      "bbox_min": [
        -3279.288330078125,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3264.46923828125,
        -4282.5419921875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.652239978313446,
        -0.7580124735832214
      ],
      "plane_d": 3613.9052734375,
      "bbox_min": [
        -3279.288330078125,
        -4317.43408203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3270.311767578125,
        -4282.5419921875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3279.288330078125,
        -4288.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3270.311767578125,
        -4282.5419921875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1248.33935546875,
      "bbox_min": [
        -3271.22412109375,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3264.46923828125,
        -4284.58056640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3271.22412109375,
        -4288.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3268.512939453125,
        -4284.58056640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123750805854797,
        -0.35355350375175476,
        -0.7071043848991394
      ],
      "plane_d": -2762.47216796875,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3277.904052734375,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3283.776611328125,
        -4288.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3277.904052734375,
        -4280.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4472.3642578125,
      "bbox_min": [
        -3412.019775390625,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3342.380126953125,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6466192007064819,
        0.6927235722541809,
        -0.3194020688533783
      ],
      "plane_d": 1123.286865234375,
      "bbox_min": [
        -3410.255615234375,
        -4288.40478515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3342.380126953125,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2604.05419921875,
      "bbox_min": [
        -3382.3056640625,
        -4288.40478515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3342.380126953125,
        -4260.1806640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2481.8486328125,
      "bbox_min": [
        -3382.3056640625,
        -4283.48974609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3344.14453125,
        -4260.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3382.3056640625,
        -4283.48974609375,
        1077.5
      ],
      "bbox_max": [
        -3368.223388671875,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123758554458618,
        -0.3535555601119995,
        -0.7071027159690857
      ],
      "plane_d": 1311.0390625,
      "bbox_min": [
        -3377.200439453125,
        -4288.40478515625,
        1077.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3377.200439453125,
        -4285.40869140625,
        1077.5
      ],
      "bbox_max": [
        -3368.223388671875,
        -4280.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5490.81103515625,
      "bbox_min": [
        -3410.255615234375,
        -4281.931640625,
        1052.623779296875
      ],
      "bbox_max": [
        -3369.824951171875,
        -4258.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1333.422607421875,
      "bbox_min": [
        -3410.255615234375,
        -4281.931640625,
        1052.623779296875
      ],
      "bbox_max": [
        -3377.199462890625,
        -4260.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3386.176513671875,
        -4281.931640625,
        1077.5
      ],
      "bbox_max": [
        -3377.199462890625,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3783.358154296875,
      "bbox_min": [
        -3384.574951171875,
        -4277.1650390625,
        1077.5
      ],
      "bbox_max": [
        -3369.824951171875,
        -4267.97607421875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3381.688232421875,
        -4277.1650390625,
        1077.5
      ],
      "bbox_max": [
        -3372.711669921875,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4374.06884765625,
      "bbox_min": [
        -3381.688232421875,
        -4319.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3366.869384765625,
        -4282.54248046875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.652239978313446,
        -0.7580124735832214
      ],
      "plane_d": 3613.9052734375,
      "bbox_min": [
        -3381.688232421875,
        -4317.43408203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3372.711669921875,
        -4282.54248046875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3381.688232421875,
        -4288.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3372.711669921875,
        -4282.54248046875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123758554458618,
        -0.3535555601119995,
        -0.7071027159690857
      ],
      "plane_d": 1311.0390625,
      "bbox_min": [
        -3373.6240234375,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3366.869384765625,
        -4284.5810546875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3373.6240234375,
        -4288.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3370.9130859375,
        -4284.5810546875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.612373948097229,
        -0.35355451703071594,
        -0.7071048617362976
      ],
      "plane_d": -2825.17919921875,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3380.30419921875,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3386.176513671875,
        -4288.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3380.30419921875,
        -4280.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3118.83984375,
      "bbox_min": [
        -3359.619873046875,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27660542726516724,
        -0.9063540101051331,
        -0.3193928301334381
      ],
      "plane_d": -4528.5654296875,
      "bbox_min": [
        -3359.619873046875,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6466192007064819,
        0.6927235722541809,
        -0.3194020688533783
      ],
      "plane_d": 1211.201904296875,
      "bbox_min": [
        -3357.855712890625,
        -4366.404296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2689.243896484375,
      "bbox_min": [
        -3329.90576171875,
        -4366.404296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4338.1806640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2477.6875,
      "bbox_min": [
        -3329.90576171875,
        -4361.48974609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3291.74462890625,
        -4338.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3329.90576171875,
        -4361.48974609375,
        1077.5
      ],
      "bbox_max": [
        -3315.823486328125,
        -4350.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1251.380859375,
      "bbox_min": [
        -3324.80078125,
        -4366.404296875,
        1077.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4358.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3324.80078125,
        -4363.40869140625,
        1077.5
      ],
      "bbox_max": [
        -3315.823486328125,
        -4358.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5510.96142578125,
      "bbox_min": [
        -3357.855712890625,
        -4359.931640625,
        1052.623779296875
      ],
      "bbox_max": [
        -3317.425048828125,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1278.38671875,
      "bbox_min": [
        -3357.855712890625,
        -4359.931640625,
        1052.623779296875
      ],
      "bbox_max": [
        -3324.80029296875,
        -4338.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3333.776611328125,
        -4359.931640625,
        1077.5
      ],
      "bbox_max": [
        -3324.80029296875,
        -4350.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3838.512451171875,
      "bbox_min": [
        -3332.175048828125,
        -4355.166015625,
        1077.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4345.97607421875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3329.288330078125,
        -4355.166015625,
        1077.5
      ],
      "bbox_max": [
        -3320.311767578125,
        -4350.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4342.3544921875,
      "bbox_min": [
        -3329.288330078125,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3314.46923828125,
        -4360.54248046875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.652239978313446,
        -0.7580124735832214
      ],
      "plane_d": 3664.77978515625,
      "bbox_min": [
        -3329.288330078125,
        -4395.43408203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3320.311767578125,
        -4360.54248046875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3329.288330078125,
        -4366.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3320.311767578125,
        -4360.54248046875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1251.380859375,
      "bbox_min": [
        -3321.224365234375,
        -4371.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3314.46923828125,
        -4362.5810546875,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3321.224365234375,
        -4366.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3318.51318359375,
        -4362.5810546875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123750805854797,
        -0.35355350375175476,
        -0.7071043848991394
      ],
      "plane_d": -2820.668212890625,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3327.904052734375,
        -4358.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3333.776611328125,
        -4366.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3327.904052734375,
        -4358.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1096.5,
      "bbox_min": [
        -3294.702880859375,
        -4302.65087890625,
        1082.5
      ],
      "bbox_max": [
        -3250.0,
        -4259.34912109375,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1093.5,
      "bbox_min": [
        -3294.702880859375,
        -4302.65087890625,
        1082.5
      ],
      "bbox_max": [
        -3250.0,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        -0.49999579787254333,
        0.0
      ],
      "plane_d": 674.108642578125,
      "bbox_min": [
        -3294.702880859375,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3250.0,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": 4955.072265625,
      "bbox_min": [
        -3294.702880859375,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3250.0,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4259.34912109375,
      "bbox_min": [
        -3294.702880859375,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -708.46826171875,
      "bbox_min": [
        -3294.702880859375,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3282.175048828125,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 682.920654296875,
      "bbox_min": [
        -3282.175048828125,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 4963.658203125,
      "bbox_min": [
        -3282.175048828125,
        -4280.75,
        1093.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4267.97607421875,
      "bbox_min": [
        -3282.175048828125,
        -4267.97607421875,
        1093.5
      ],
      "bbox_max": [
        -3267.425048828125,
        -4267.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4302.65087890625,
      "bbox_min": [
        -3276.905517578125,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3262.5,
        -4302.65087890625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": -717.409912109375,
      "bbox_min": [
        -3294.702880859375,
        -4271.82470703125,
        1093.5
      ],
      "bbox_max": [
        -3287.5,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -708.46826171875,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 682.920654296875,
      "bbox_min": [
        -3282.175048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 4963.658203125,
      "bbox_min": [
        -3282.175048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3282.175048828125,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3267.425048828125,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4267.97607421875,
      "bbox_min": [
        -3282.175048828125,
        -4267.97607421875,
        1082.5
      ],
      "bbox_max": [
        -3267.425048828125,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4267.97607421875,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -708.46826171875,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 682.920654296875,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 4963.658203125,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        -3289.550048828125,
        -4293.52392578125,
        1117.5
      ],
      "bbox_max": [
        -3260.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.5,
      "bbox_min": [
        -3402.0,
        -4380.65087890625,
        1082.5
      ],
      "bbox_max": [
        -3276.905517578125,
        -4259.34912109375,
        1117.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1093.5,
      "bbox_min": [
        -3402.0,
        -4380.65087890625,
        1082.5
      ],
      "bbox_max": [
        -3276.905517578125,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.39218589663505554,
        -0.9198859930038452,
        -0.0
      ],
      "plane_d": -5277.45751953125,
      "bbox_min": [
        -3402.0,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3276.905517578125,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4330458641052246,
        -0.9013720154762268,
        0.0
      ],
      "plane_d": -2454.65087890625,
      "bbox_min": [
        -3402.0,
        -4324.82080078125,
        1093.5
      ],
      "bbox_max": [
        -3276.905517578125,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38282665610313416,
        0.9238203167915344,
        0.0
      ],
      "plane_d": 2691.546875,
      "bbox_min": [
        -3402.0,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3294.702880859375,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36642909049987793,
        0.9304460287094116,
        -0.0
      ],
      "plane_d": 5211.509765625,
      "bbox_min": [
        -3402.0,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3294.702880859375,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": -805.744873046875,
      "bbox_min": [
        -3402.0,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4264.95654296875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": -5077.88671875,
      "bbox_min": [
        -3402.0,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4268.13525390625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 771.6015625,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4268.13525390625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4268.13525390625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -797.1494140625,
      "bbox_min": [
        -3391.949951171875,
        -4280.75,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4268.13525390625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        -0.0
      ],
      "plane_d": 5052.3388671875,
      "bbox_min": [
        -3365.33837890625,
        -4280.75,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4275.7470703125,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        -0.49999579787254333,
        0.0
      ],
      "plane_d": -5086.708984375,
      "bbox_min": [
        -3402.0,
        -4288.51171875,
        1093.5
      ],
      "bbox_max": [
        -3397.6630859375,
        -4281.0,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        0.49999579787254333,
        -0.0
      ],
      "plane_d": 5043.4072265625,
      "bbox_min": [
        -3392.737548828125,
        -4281.0,
        1093.5
      ],
      "bbox_max": [
        -3294.702880859375,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4259.34912109375,
      "bbox_min": [
        -3392.737548828125,
        -4275.7470703125,
        1093.5
      ],
      "bbox_max": [
        -3364.5,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4267.97607421875,
      "bbox_min": [
        -3392.737548828125,
        -4275.7470703125,
        1093.5
      ],
      "bbox_max": [
        -3365.33837890625,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        -0.0
      ],
      "plane_d": 5052.3388671875,
      "bbox_min": [
        -3384.666748046875,
        -4275.7470703125,
        1093.5
      ],
      "bbox_max": [
        -3365.33837890625,
        -4267.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -797.1494140625,
      "bbox_min": [
        -3384.666748046875,
        -4268.13525390625,
        1093.5
      ],
      "bbox_max": [
        -3384.574951171875,
        -4267.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": -805.744873046875,
      "bbox_min": [
        -3392.737548828125,
        -4264.95654296875,
        1093.5
      ],
      "bbox_max": [
        -3389.5,
        -4259.34912109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": -717.409912109375,
      "bbox_min": [
        -3300.0,
        -4281.0,
        1093.5
      ],
      "bbox_max": [
        -3294.702880859375,
        -4271.82470703125,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4302.65087890625,
      "bbox_min": [
        -3312.5,
        -4324.82080078125,
        1093.5
      ],
      "bbox_max": [
        -3276.905517578125,
        -4302.65087890625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3312.5,
      "bbox_min": [
        -3312.5,
        -4324.82080078125,
        1093.5
      ],
      "bbox_max": [
        -3312.5,
        -4314.66162109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": -721.7119140625,
      "bbox_min": [
        -3397.6630859375,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4288.51171875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": 5037.3740234375,
      "bbox_min": [
        -3350.0,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4324.82080078125,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        -0.49999579787254333,
        -0.0
      ],
      "plane_d": -5080.6748046875,
      "bbox_min": [
        -3350.0,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        -0.49999579787254333,
        0.0
      ],
      "plane_d": 678.41015625,
      "bbox_min": [
        -3339.550048828125,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4380.65087890625,
      "bbox_min": [
        -3339.550048828125,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -712.77001953125,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        -0.0
      ],
      "plane_d": -5071.5068359375,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 687.22216796875,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 5045.958984375,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4371.52392578125,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4345.97607421875,
      "bbox_min": [
        -3332.175048828125,
        -4345.97607421875,
        1093.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4345.97607421875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3312.5,
      "bbox_min": [
        -3312.5,
        -4337.34912109375,
        1093.5
      ],
      "bbox_max": [
        -3312.5,
        -4324.82080078125,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4302.65087890625,
      "bbox_min": [
        -3397.6630859375,
        -4337.34912109375,
        1093.5
      ],
      "bbox_max": [
        -3337.5,
        -4288.51171875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660278916358948,
        -0.49999579787254333,
        0.0
      ],
      "plane_d": -5086.708984375,
      "bbox_min": [
        -3397.6630859375,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3389.5,
        -4288.51171875,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3337.5,
      "bbox_min": [
        -3337.5,
        -4337.34912109375,
        1093.5
      ],
      "bbox_max": [
        -3337.5,
        -4314.162109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -712.77001953125,
      "bbox_min": [
        -3391.949951171875,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        -0.0
      ],
      "plane_d": -5071.5068359375,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 687.22216796875,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 5045.958984375,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4371.52392578125,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4345.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4345.97607421875,
      "bbox_min": [
        -3332.175048828125,
        -4345.97607421875,
        1082.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4345.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -797.1494140625,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": -5077.88671875,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 771.6015625,
      "bbox_min": [
        -3384.574951171875,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        -0.0
      ],
      "plane_d": 5052.3388671875,
      "bbox_min": [
        -3384.574951171875,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3384.574951171875,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3369.824951171875,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4267.97607421875,
      "bbox_min": [
        -3384.574951171875,
        -4267.97607421875,
        1082.5
      ],
      "bbox_max": [
        -3369.824951171875,
        -4267.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -712.77001953125,
      "bbox_min": [
        -3391.949951171875,
        -4371.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        -0.0
      ],
      "plane_d": -5071.5068359375,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 687.22216796875,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 5045.958984375,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4371.52392578125,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4345.97607421875,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        -3339.550048828125,
        -4371.52392578125,
        1117.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": -797.1494140625,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": -5077.88671875,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 771.6015625,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        -0.0
      ],
      "plane_d": 5052.3388671875,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4267.97607421875,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1096.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        -3391.949951171875,
        -4293.52392578125,
        1117.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4267.97607421875,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3337.999755859375,
      "bbox_min": [
        -3560.599853515625,
        -4673.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4647.2685546875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4653.2685546875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.623779296875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1087.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4595.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4595.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3337.999755859375,
        -4595.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.623779296875,
      "bbox_min": [
        -3337.999755859375,
        -4595.7685546875,
        1087.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3336.999755859375,
      "bbox_min": [
        -3336.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3336.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3125.14599609375,
      "bbox_min": [
        -3336.999755859375,
        -4647.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3554.599609375,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4653.2685546875,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3554.599609375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4647.2685546875,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3554.599609375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3560.599853515625,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3554.599609375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.623779296875,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1087.623779296875
      ],
      "bbox_max": [
        -3554.599609375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4648.36865234375,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4648.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4652.36865234375,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4648.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4055.252197265625,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4648.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2521.3623046875,
      "bbox_min": [
        -3554.599853515625,
        -4650.36865234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4648.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3337.999755859375,
      "bbox_min": [
        -3522.099853515625,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4563.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4404.36865234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4563.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4563.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1087.623779296875,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1087.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4563.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3336.999755859375,
      "bbox_min": [
        -3336.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3336.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3125.14599609375,
      "bbox_min": [
        -3336.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3336.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4404.36865234375,
      "bbox_min": [
        -3336.999755859375,
        -4404.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4413.39990234375,
      "bbox_min": [
        -3522.099853515625,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4546.0,
      "bbox_min": [
        -3522.099853515625,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3483.0,
      "bbox_min": [
        -3522.099853515625,
        -4546.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1081.65380859375,
      "bbox_min": [
        -3367.056640625,
        -4546.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4413.39990234375,
        1081.6539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3347.056640625,
      "bbox_min": [
        -3367.056640625,
        -4546.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4413.39990234375,
        1081.6539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45628005266189575,
        0.8898362517356873,
        -0.0
      ],
      "plane_d": 5463.52392578125,
      "bbox_min": [
        -3367.056640625,
        -4546.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4413.39990234375,
        1081.6539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4514262080192566,
        -0.8923085331916809,
        0.0
      ],
      "plane_d": -2536.45703125,
      "bbox_min": [
        -3367.056640625,
        -4546.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.056640625,
        -4535.8818359375,
        1081.6539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38344883918762207,
        -0.0,
        0.9235621094703674
      ],
      "plane_d": 292.119384765625,
      "bbox_min": [
        -3417.0,
        -4546.0,
        1081.6539306640625
      ],
      "bbox_max": [
        -3367.056640625,
        -4413.39990234375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.3896484375,
      "bbox_min": [
        -3450.0,
        -4546.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.15500178933143616,
        -0.0,
        0.9879142045974731
      ],
      "plane_d": -566.6591796875,
      "bbox_min": [
        -3450.0,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6748446226119995,
        -0.0,
        0.7379598617553711
      ],
      "plane_d": 1492.4248046875,
      "bbox_min": [
        -3426.66552734375,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1090.623779296875,
      "bbox_min": [
        -3443.75,
        -4501.68408203125,
        1090.623779296875
      ],
      "bbox_max": [
        -3422.499755859375,
        -4457.85302734375,
        1102.3896484375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.965925395488739,
        -0.25882065296173096,
        -0.0
      ],
      "plane_d": -4465.82763671875,
      "bbox_min": [
        -3443.75,
        -4501.68408203125,
        1090.623779296875
      ],
      "bbox_max": [
        -3422.499755859375,
        -4457.85302734375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070982456207275,
        0.7071154117584229,
        0.0
      ],
      "plane_d": 753.444091796875,
      "bbox_min": [
        -3443.75,
        -4501.68408203125,
        1090.623779296875
      ],
      "bbox_max": [
        -3422.499755859375,
        -4457.85302734375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070982456207275,
        -0.7071154117584229,
        -0.0
      ],
      "plane_d": -5581.982421875,
      "bbox_min": [
        -3443.75,
        -4491.61865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3422.499755859375,
        -4457.85302734375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3443.749755859375,
      "bbox_min": [
        -3443.75,
        -4491.61865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3422.499755859375,
        -4468.2451171875,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9377774000167847,
        0.34723716974258423,
        0.0
      ],
      "plane_d": -1653.341064453125,
      "bbox_min": [
        -3443.75,
        -4491.61865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3422.499755859375,
        -4468.2451171875,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 2591.099853515625,
      "bbox_min": [
        -3443.75,
        -4491.2919921875,
        1090.623779296875
      ],
      "bbox_max": [
        -3442.249755859375,
        -4468.2451171875,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4481.39990234375,
      "bbox_min": [
        -3443.75,
        -4481.39990234375,
        1093.0
      ],
      "bbox_max": [
        -3443.437744140625,
        -4478.39990234375,
        1093.62451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4478.39990234375,
      "bbox_min": [
        -3443.75,
        -4478.39990234375,
        1093.0
      ],
      "bbox_max": [
        -3443.437744140625,
        -4478.39990234375,
        1093.62451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3443.25,
      "bbox_min": [
        -3443.75,
        -4481.39990234375,
        1093.0
      ],
      "bbox_max": [
        -3443.25,
        -4478.39990234375,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        -3443.75,
        -4481.39990234375,
        1093.0
      ],
      "bbox_max": [
        -3443.25,
        -4478.39990234375,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4481.39990234375,
      "bbox_min": [
        -3443.75,
        -4481.39990234375,
        1093.0
      ],
      "bbox_max": [
        -3443.25,
        -4478.39990234375,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4478.39990234375,
      "bbox_min": [
        -3443.75,
        -4478.39990234375,
        1093.0
      ],
      "bbox_max": [
        -3443.25,
        -4478.39990234375,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25880467891693115,
        -0.9659296870231628,
        -0.0
      ],
      "plane_d": -5195.2900390625,
      "bbox_min": [
        -3449.999755859375,
        -4470.84326171875,
        1090.623779296875
      ],
      "bbox_max": [
        -3436.249755859375,
        -4454.1689453125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1090.6236572265625,
      "bbox_min": [
        -3449.999755859375,
        -4470.84326171875,
        1090.623779296875
      ],
      "bbox_max": [
        -3436.249755859375,
        -4454.1689453125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.9659211039543152,
        -0.0
      ],
      "plane_d": 5209.8505859375,
      "bbox_min": [
        -3449.999755859375,
        -4470.84326171875,
        1090.623779296875
      ],
      "bbox_max": [
        -3442.249755859375,
        -4466.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18615910410881042,
        0.6947371363639832,
        0.6947554349899292
      ],
      "plane_d": 2987.344970703125,
      "bbox_min": [
        -3449.999755859375,
        -4470.84326171875,
        1090.623779296875
      ],
      "bbox_max": [
        -3442.249755859375,
        -4466.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3458.844482421875,
      "bbox_min": [
        -3449.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3436.249755859375,
        -4488.69384765625,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1090.623779296875,
      "bbox_min": [
        -3449.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3436.249755859375,
        -4488.69384765625,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883668661117554,
        -0.9659211039543152,
        0.0
      ],
      "plane_d": -3444.35546875,
      "bbox_min": [
        -3449.999755859375,
        -4493.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3442.249755859375,
        -4488.69384765625,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18616147339344025,
        -0.6947459578514099,
        0.6947459578514099
      ],
      "plane_d": -3237.19921875,
      "bbox_min": [
        -3449.999755859375,
        -4493.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3442.249755859375,
        -4488.69384765625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.3896484375,
      "bbox_min": [
        -3483.0,
        -4546.0,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.15500178933143616,
        0.0,
        0.9879142045974731
      ],
      "plane_d": -1636.17138671875,
      "bbox_min": [
        -3483.0,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6748446226119995,
        0.0,
        0.7379598617553711
      ],
      "plane_d": -3164.003173828125,
      "bbox_min": [
        -3483.0,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3473.33447265625,
        -4413.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        2.441406286379788e-05,
        -0.0
      ],
      "plane_d": 3482.10791015625,
      "bbox_min": [
        -3483.0,
        -4535.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -3483.0,
        -4535.36865234375,
        1093.623779296875
      ],
      "bbox_max": [
        -3481.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4525.36865234375,
      "bbox_min": [
        -3483.0,
        -4535.36865234375,
        1093.623779296875
      ],
      "bbox_max": [
        -3481.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4424.16845703125,
      "bbox_min": [
        -3483.0,
        -4434.16845703125,
        1093.623779296875
      ],
      "bbox_max": [
        -3481.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4434.16845703125,
      "bbox_min": [
        -3483.0,
        -4434.16845703125,
        1093.623779296875
      ],
      "bbox_max": [
        -3481.999755859375,
        -4434.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4535.36865234375,
      "bbox_min": [
        -3483.0,
        -4535.36865234375,
        1093.623779296875
      ],
      "bbox_max": [
        -3481.999755859375,
        -4535.36865234375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1090.623779296875,
      "bbox_min": [
        -3481.999755859375,
        -4535.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3466.999755859375,
      "bbox_min": [
        -3481.999755859375,
        -4535.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4505.36865234375,
      "bbox_min": [
        -3466.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4454.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.8722839488182217e-05,
        -1.0,
        -0.0
      ],
      "plane_d": -4454.26806640625,
      "bbox_min": [
        -3466.999755859375,
        -4493.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4454.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4490.36865234375,
      "bbox_min": [
        -3466.999755859375,
        -4493.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4466.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.16845703125,
      "bbox_min": [
        -3466.999755859375,
        -4469.16845703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4466.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2386.87060546875,
      "bbox_min": [
        -3466.999755859375,
        -4469.16845703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4466.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3948.479248046875,
      "bbox_min": [
        -3466.999755859375,
        -4493.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3449.999755859375,
        -4490.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1688.8369140625,
      "bbox_min": [
        -3481.999755859375,
        -4535.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4424.16845703125,
      "bbox_min": [
        -3481.999755859375,
        -4535.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4535.3681640625,
      "bbox_min": [
        -3481.999755859375,
        -4535.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4454.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 5455.76318359375,
      "bbox_min": [
        -3481.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4454.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        -0.9238727688789368,
        0.0
      ],
      "plane_d": -2821.708984375,
      "bbox_min": [
        -3481.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4490.36865234375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        -0.3826998770236969,
        0.0
      ],
      "plane_d": 1492.7208251953125,
      "bbox_min": [
        -3481.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4490.36865234375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785960793495178,
        -0.2810952961444855,
        0.6785960793495178
      ],
      "plane_d": 354.3046875,
      "bbox_min": [
        -3481.999755859375,
        -4505.36865234375,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4490.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810942232608795,
        -0.6786211133003235,
        0.6785715818405151
      ],
      "plane_d": -2814.8076171875,
      "bbox_min": [
        -3477.606201171875,
        -4496.88330078125,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4490.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 4921.4794921875,
      "bbox_min": [
        -3481.99951171875,
        -4469.16845703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4454.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786071062088013,
        0.281086802482605,
        0.6785887479782104
      ],
      "plane_d": 2872.796875,
      "bbox_min": [
        -3481.99951171875,
        -4469.16845703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4454.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810976505279541,
        0.6785956025123596,
        0.6785956025123596
      ],
      "plane_d": 3265.195068359375,
      "bbox_min": [
        -3477.606201171875,
        -4469.16845703125,
        1090.623779296875
      ],
      "bbox_max": [
        -3466.999755859375,
        -4462.65380859375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3508.06005859375,
      "bbox_min": [
        -3522.099853515625,
        -4535.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3483.0,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4511.36865234375,
      "bbox_min": [
        -3508.06005859375,
        -4535.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3483.0,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4448.7685546875,
      "bbox_min": [
        -3508.06005859375,
        -4511.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3483.0,
        -4424.16845703125,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4649069011211395,
        0.0,
        0.8853597044944763
      ],
      "plane_d": -2595.2822265625,
      "bbox_min": [
        -3508.06005859375,
        -4511.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3483.0,
        -4448.7685546875,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9860352277755737,
        0.0,
        0.16653744876384735
      ],
      "plane_d": -3637.66943359375,
      "bbox_min": [
        -3508.06005859375,
        -4511.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4448.7685546875,
        1093.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8677623867988586,
        0.0,
        0.49697932600975037
      ],
      "plane_d": -3581.065185546875,
      "bbox_min": [
        -3508.06005859375,
        -4511.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4448.7685546875,
        1093.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3490.0,
      "bbox_min": [
        -3508.06005859375,
        -4504.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4454.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1065.623779296875,
      "bbox_min": [
        -3508.06005859375,
        -4504.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4454.66845703125,
        1065.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3505.0,
      "bbox_min": [
        -3508.06005859375,
        -4504.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4454.66845703125,
        1065.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4474.66845703125,
      "bbox_min": [
        -3508.06005859375,
        -4484.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3505.0,
        -4474.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4484.86865234375,
      "bbox_min": [
        -3508.06005859375,
        -4484.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3505.0,
        -4484.86865234375,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4504.86865234375,
      "bbox_min": [
        -3505.0,
        -4504.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4454.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4454.66845703125,
      "bbox_min": [
        -3505.0,
        -4454.66845703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3490.0,
        -4454.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -3485.999755859375,
        -4434.16845703125,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4424.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1093.123779296875,
      "bbox_min": [
        -3485.999755859375,
        -4434.16845703125,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4424.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3485.999755859375,
      "bbox_min": [
        -3485.999755859375,
        -4434.16845703125,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4424.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4434.16845703125,
      "bbox_min": [
        -3485.999755859375,
        -4434.16845703125,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4434.16845703125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -3485.999755859375,
        -4535.36865234375,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4525.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1093.123779296875,
      "bbox_min": [
        -3485.999755859375,
        -4535.36865234375,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4525.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3485.999755859375,
      "bbox_min": [
        -3485.999755859375,
        -4535.36865234375,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4525.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4535.36865234375,
      "bbox_min": [
        -3485.999755859375,
        -4535.36865234375,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4525.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4525.36865234375,
      "bbox_min": [
        -3485.999755859375,
        -4525.36865234375,
        1093.123779296875
      ],
      "bbox_max": [
        -3483.0,
        -4525.36865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4488.2685546875,
      "bbox_min": [
        -3522.099853515625,
        -4488.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4470.66845703125,
        1072.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4470.66845703125,
      "bbox_min": [
        -3522.099853515625,
        -4488.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4470.66845703125,
        1072.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24094408750534058,
        0.0,
        0.9705390334129333
      ],
      "plane_d": -1886.0755615234375,
      "bbox_min": [
        -3522.099853515625,
        -4488.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4470.66845703125,
        1072.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3515.0,
      "bbox_min": [
        -3522.099853515625,
        -4488.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4470.66845703125,
        1071.2408447265625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.784268319606781,
        0.0,
        0.6204219460487366
      ],
      "plane_d": -3419.618896484375,
      "bbox_min": [
        -3515.0,
        -4488.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4470.66845703125,
        1071.2408447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4474.66845703125,
      "bbox_min": [
        -3515.0,
        -4484.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4474.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4484.86865234375,
      "bbox_min": [
        -3515.0,
        -4484.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4474.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1065.623779296875,
      "bbox_min": [
        -3515.0,
        -4484.86865234375,
        1065.623779296875
      ],
      "bbox_max": [
        -3508.06005859375,
        -4474.66845703125,
        1065.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4486.068359375,
      "bbox_min": [
        -3522.099853515625,
        -4487.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4471.21875,
        1060.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4487.86865234375,
      "bbox_min": [
        -3522.099853515625,
        -4487.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4486.068359375,
        1060.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4522362947463989,
        0.0,
        0.8918981552124023
      ],
      "plane_d": -2535.133056640625,
      "bbox_min": [
        -3522.099853515625,
        -4487.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4486.068359375,
        1060.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3522.099853515625,
      "bbox_min": [
        -3522.099853515625,
        -4487.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3522.099853515625,
        -4486.068359375,
        1056.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4473.0185546875,
      "bbox_min": [
        -3522.099609375,
        -4473.0185546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4471.21875,
        1060.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4471.21875,
      "bbox_min": [
        -3522.099609375,
        -4473.0185546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4471.21875,
        1060.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4522486925125122,
        0.0,
        0.8918919563293457
      ],
      "plane_d": -2535.169921875,
      "bbox_min": [
        -3522.099609375,
        -4473.0185546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -4471.21875,
        1060.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3522.099609375,
      "bbox_min": [
        -3522.099609375,
        -4473.0185546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3522.099609375,
        -4471.21875,
        1056.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9278242588043213,
        -0.3730178475379944,
        0.0
      ],
      "plane_d": 1474.636474609375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3925205171108246,
        -0.9197432398796082,
        0.0
      ],
      "plane_d": -2858.22802734375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06411544978618622,
        -0.150238499045372,
        0.9865686893463135
      ],
      "plane_d": -1561.7010498046875,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15470170974731445,
        -0.06219439208507538,
        0.9860016703605652
      ],
      "plane_d": -848.2979125976562,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513059735298157,
        -0.26184308528900146,
        0.7122068405151367
      ],
      "plane_d": 250.04437255859375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27256160974502563,
        -0.6386798024177551,
        0.7195821404457092
      ],
      "plane_d": -2778.075927734375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3426.66552734375,
        -4563.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9278242588043213,
        -0.3730178475379944,
        -0.0
      ],
      "plane_d": -4927.35107421875,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3925205171108246,
        -0.9197432398796082,
        -0.0
      ],
      "plane_d": -5566.61962890625,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06411544233560562,
        -0.15023845434188843,
        0.9865685105323792
      ],
      "plane_d": -2004.0972900390625,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15470170974731445,
        -0.06219439208507538,
        0.9860016107559204
      ],
      "plane_d": -1915.739501953125,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6513000130653381,
        -0.26184070110321045,
        0.7122132182121277
      ],
      "plane_d": -4243.9423828125,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4546.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2725662291049957,
        -0.638690710067749,
        0.7195705771446228
      ],
      "plane_d": -4658.8037109375,
      "bbox_min": [
        -3473.33447265625,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4563.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9278242588043213,
        0.3730178475379944,
        -0.0
      ],
      "plane_d": 4816.65234375,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3925205171108246,
        0.9197432398796082,
        -0.0
      ],
      "plane_d": 5382.119140625,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06411544233560562,
        0.15023845434188843,
        0.9865685105323792
      ],
      "plane_d": -215.6544189453125,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15470170974731445,
        0.06219439208507538,
        0.9860016107559204
      ],
      "plane_d": -291.0733642578125,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6512991786003113,
        0.26184508204460144,
        0.712212324142456
      ],
      "plane_d": 2595.980712890625,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27257317304611206,
        0.638685941696167,
        0.7195721864700317
      ],
      "plane_d": 2944.189453125,
      "bbox_min": [
        -3450.0,
        -4396.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3426.66552734375,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9278242588043213,
        0.3730178475379944,
        0.0
      ],
      "plane_d": -1585.3348388671875,
      "bbox_min": [
        -3483.0,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3925205171108246,
        0.9197432398796082,
        0.0
      ],
      "plane_d": 2673.7275390625,
      "bbox_min": [
        -3483.0,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06411544978618622,
        0.150238499045372,
        0.9865686893463135
      ],
      "plane_d": -658.0509033203125,
      "bbox_min": [
        -3483.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15470170974731445,
        0.06219439208507538,
        0.9860016703605652
      ],
      "plane_d": -1358.5152587890625,
      "bbox_min": [
        -3483.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6513034701347351,
        0.2618468105792999,
        0.7122078537940979
      ],
      "plane_d": -1897.98583984375,
      "bbox_min": [
        -3483.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2725698947906494,
        0.638678252696991,
        0.7195802927017212
      ],
      "plane_d": 1063.4033203125,
      "bbox_min": [
        -3473.33447265625,
        -4396.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1054.7738037109375,
      "bbox_min": [
        -3632.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.01888239197432995,
        0.9998217225074768
      ],
      "plane_d": -1147.5177001953125,
      "bbox_min": [
        -3632.999755859375,
        -4679.7998046875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4302.2685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4302.2685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4653.2939453125,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.01888239197432995,
        -0.9998217225074768
      ],
      "plane_d": 1142.5185546875,
      "bbox_min": [
        -3632.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4302.2685546875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4302.2685546875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3923.259033203125,
      "bbox_min": [
        -3632.999755859375,
        -4304.1669921875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4302.2685546875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4651.7568359375,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4655.33154296875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3675.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1054.7738037109375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4249.7685546875,
        1059.7738037109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1054.7738037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4294.7685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1054.7738037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4666.13134765625,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4294.7685546875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7496428489685059,
        -0.6618426442146301
      ],
      "plane_d": 3917.63671875,
      "bbox_min": [
        -3675.999755859375,
        -4296.6669921875,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4294.7685546875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4664.30908203125,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.762873649597168,
        -0.6465476155281067
      ],
      "plane_d": -2880.939697265625,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4668.54638671875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 1057.446044921875,
      "bbox_min": [
        -3939.26220703125,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1100.3785400390625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2712554931640625,
        0.3530268669128418,
        0.8954285979270935
      ],
      "plane_d": 1485.3206787109375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2750813663005829,
        0.35142311453819275,
        0.894892156124115
      ],
      "plane_d": -215.431884765625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2754322588443756,
        0.3464488685131073,
        0.8967219591140747
      ],
      "plane_d": 1463.6072998046875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27700290083885193,
        0.3484245240688324,
        0.8954717516899109
      ],
      "plane_d": -237.17449951171875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3248736560344696,
        0.30733799934387207,
        0.894427478313446
      ],
      "plane_d": 1431.6265869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3270551264286041,
        0.3094017207622528,
        0.892919659614563
      ],
      "plane_d": -576.7142333984375,
      "bbox_min": [
        -2945.2109375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3714085817337036,
        1.1238243132538628e-05,
        0.9284694790840149
      ],
      "plane_d": -2031.978759765625,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4909.36328125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3939.26220703125,
        -5079.7685546875,
        1317.4210205078125
      ],
      "bbox_max": [
        -3758.24658203125,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3556.305419921875,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -3985.582763671875,
        -4266.263671875,
        1353.5482177734375
      ],
      "bbox_max": [
        -3900.749755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -4007.749267578125,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3900.749755859375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3802.58349609375,
        -4266.263671875,
        1353.5482177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -3888.191162109375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3835.11669921875,
        -4333.81396484375,
        1329.1610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43041878938674927,
        0.12140591442584991,
        0.8944273591041565
      ],
      "plane_d": 1038.8125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3556.986083984375,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3239.638916015625,
        -4879.7685546875,
        1317.4210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": -3425.414306640625,
      "bbox_min": [
        -3248.5048828125,
        -4906.9423828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -3239.638916015625,
        -4879.76904296875,
        1315.92041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": -3425.414306640625,
      "bbox_min": [
        -3248.5048828125,
        -4906.36181640625,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3237.16748046875,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": -2032.00439453125,
      "bbox_min": [
        -2978.129638671875,
        -4910.2978515625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2297457456588745,
        0.4098278880119324,
        0.8827558755874634
      ],
      "plane_d": 157.9915771484375,
      "bbox_min": [
        -2214.77978515625,
        -4508.150390625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2978.129638671875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -2962.83203125,
        -3780.262451171875,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3014.40673828125,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3780.262451171875,
        1322.556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3311.842041015625,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -3100.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3237.16748046875,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3194.5439453125,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: wtcharge",
      "entity_class": "CSlidingDoor",
      "piece_name": "wtcharge",
      "offset": 30065,
      "centroid": [
        -3275.0,
        -4267.8759765625,
        1100.0
      ],
      "bbox_min": [
        -3276.5,
        -4267.8759765625,
        1099.0
      ],
      "bbox_max": [
        -3273.5,
        -4267.8759765625,
        1101.0
      ],
      "dimensions_source": {
        "span_x": 3.0,
        "span_y": 0.0,
        "height_z": 2.0,
        "door_width": 3.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3276.5,
          -4267.8759765625,
          1099.0
        ],
        [
          -3276.5,
          -4267.8759765625,
          1101.0
        ],
        [
          -3273.5,
          -4267.8759765625,
          1101.0
        ],
        [
          -3273.5,
          -4267.8759765625,
          1099.0
        ]
      ],
      "plane_distance": 4267.876
    }
  ],
  "tutorial_messages": []
}